//
// ./src/store/firebasedata/index.js
//
import * as firebase from 'firebase'

export default {
  // firestore
  // this.db = firebase.firestore()
  // export const propsRef = db.ref('names-two');
  state: {
    // ===========
    // ddbb: firebase.firestore()
    // ddbb.settings({
    //      timestampsInSnapshots: true
    //    })
  },
  mutations: {
    setLoadedProperties(state, payload) {
      state.PropertiesLoaded = payload
    },
    oldStuff() {
      // setLoadedMeetups (state, payload) {
      //   state.loadedMeetups = payload
      // },
      // createMeetup (state, payload) {
      //   state.loadedMeetups.push(payload)
      // },
      // updateMeetup (state, payload) {
      //   const meetup = state.loadedMeetups.find(meetup => {
      //     return meetup.id === payload.id
      //   })
      //   if (payload.title) {
      //     meetup.title = payload.title
      //   }
      //   if (payload.description) {
      //     meetup.description = payload.description
      //   }
      //   if (payload.date) {
      //     meetup.date = payload.date
      //   }
      // }
    }
  },
  actions: {
    loadProperties({ commit }, state) {
      //   commit('setLoadedProperties', PropertiesSTATICtwo)
      // *******************************
      //   commit('setLoading', true)
      firebase
        .database()
        .ref('/test/co/Properties')
        .once('value')
        .then(data => {
          const meetups = []
          const snapshotObj = data.val()
          meetups.push(...snapshotObj)
          commit('setLoadedProperties', meetups)
          //   for (let key in snapshotObj) {
          //     meetups.push({
          //       ...snapshotObj[key]
          //  https://stackoverflow.com/questions/20881213/converting-javascript-object-with-numeric-keys-into-array var arr = Object.values(obj);
          //       //   id: key
          //       //   title: snapshotObj[key].title,
          //       //   description: snapshotObj[key].description,
          //     })
          //   }
          //   commit('setLoadedProperties', meetups)
          //   commit('setLoadedMeetups', meetups)
          //   commit('setLoading', false)
        })
        .catch(error => {
          console.log('actions>loadProperties: ' + error)
          //   commit('setLoading', false)
        })
      // *******************************
    }
  },
  getters: {
    loadedPropsCW(state) {
      // return state.PropertiesLoaded.sort((propA, propB) => {
      //   return propA.Name.localeCompare(propB.Name)
      // })
    }
  }
}

export const firebaseConfig = {
  apiKey: 'AIzaSyAd5aI3iYpB0wGiahyXpW6hhMZvl1hKMfk',
  authDomain: 'agendakit-1487098982147.firebaseapp.com',
  databaseURL: 'https://agendakit-1487098982147.firebaseio.com',
  projectId: 'agendakit-1487098982147',
  storageBucket: 'agendakit-1487098982147.appspot.com',
  messagingSenderId: '1004610887223'
}

// dis ----
// items - Can be an array of objects or array of strings. When using objects,
// will look for a text and value field.This can be changed using the item - text
// and item - value props.
// let twoPropertiesSTATIC = {
//   deals: [
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Name: 'name of property',
//       myID: 13247
//     }
//   ]
// }
// let PropertiesSTATIC = {
//   deals: [
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2051 E Pole Line Rd , Twin Falls, ID, ',
//       Address1: '2051 E Pole Line Rd',
//       Address2: '',
//       Asking_Price: ' 1,000,000100',
//       Building_Size_SqFt: '',
//       Building_Space_Building_Space: '',
//       City: 'Twin Falls',
//       Deal_Type: '',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_Type_dotmyid: '197081',
//       ID: 243881000044443709,
//       Land_Size_Acres: 22,
//       Listing_Broker: ['LeAnn Hume CWP'],
//       Listing_Broker_dotmyid: '243885',
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Pillar Falls Bank Owned Subdivision - Twin Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 13247,
//       Seller_Landlord: '',
//       Seller_Landlord_dotmyid: '',
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       Status_dotmyid: '202125820',
//       TMLink:
//         'http:20912001781201cwhome1html?page=taskmanager&topParentName=Pillar Falls Bank Owned Subdivision - Twin Falls&topParentID=13247&tm_style=__due&cmd=&iList=Property&formID=243881000044443709&formMyID=13247&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'PUD',
//       cmd: '',
//       myID: 13247,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '1-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '687 S1 Blue Lakes Blvd N , Twin Falls, ID, ',
//       Address1: '687 S1 Blue Lakes Blvd N',
//       Address2: '',
//       Asking_Price: ' 850,000100',
//       Building_Size_SqFt: '',
//       Building_Space_Building_Space: '',
//       City: 'Twin Falls',
//       Deal_Type: '',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_Type_dotmyid: '197081',
//       ID: 243881000044443629,
//       Land_Size_Acres: 198,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_Broker_dotmyid: '243881, 243885, 243888',
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'New Retail Restaurant Space For Lease - Twin Falls',
//       Notes: '',
//       Parcel_Number: 'RPT00107091800A',
//       ParentID: 41476,
//       Seller_Landlord: '',
//       Seller_Landlord_dotmyid: '',
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       Status_dotmyid: '202081877',
//       TMLink:
//         'http:20912001781201cwhome1html?page=taskmanager&topParentName=New Retail Restaurant Space For Lease - Twin Falls&topParentID=41476&tm_style=__due&cmd=&iList=Property&formID=243881000044443629&formMyID=41476&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-1',
//       cmd: '',
//       myID: 41476,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     }
//   ]
// }

// / /////////////////////////////////==
// let PropertiesSTATIC = {
//   Properties: [
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2051 E Pole Line Rd , Twin Falls, ID, ',
//       Address1: '2051 E Pole Line Rd',
//       Address2: '',
//       Asking_Price: ' 1,000,000100',
//       Building_Size_SqFt: '',
//       Building_Space_Building_Space: '',
//       City: 'Twin Falls',
//       Deal_Type: '',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_Type_dotmyid: '197081',
//       ID: 243881000044443709,
//       Land_Size_Acres: 22,
//       Listing_Broker: ['LeAnn Hume CWP'],
//       Listing_Broker_dotmyid: '243885',
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Pillar Falls Bank Owned Subdivision - Twin Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 13247,
//       Seller_Landlord: '',
//       Seller_Landlord_dotmyid: '',
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       Status_dotmyid: '202125820',
//       TMLink:
//         'http:20912001781201cwhome1html?page=taskmanager&topParentName=Pillar Falls Bank Owned Subdivision - Twin Falls&topParentID=13247&tm_style=__due&cmd=&iList=Property&formID=243881000044443709&formMyID=13247&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'PUD',
//       cmd: '',
//       myID: 13247,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '1-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '687 S1 Blue Lakes Blvd N , Twin Falls, ID, ',
//       Address1: '687 S1 Blue Lakes Blvd N',
//       Address2: '',
//       Asking_Price: ' 850,000100',
//       Building_Size_SqFt: '',
//       Building_Space_Building_Space: '',
//       City: 'Twin Falls',
//       Deal_Type: '',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_Type_dotmyid: '197081',
//       ID: 243881000044443629,
//       Land_Size_Acres: 198,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_Broker_dotmyid: '243881, 243885, 243888',
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'New Retail Restaurant Space For Lease - Twin Falls',
//       Notes: '',
//       Parcel_Number: 'RPT00107091800A',
//       ParentID: 41476,
//       Seller_Landlord: '',
//       Seller_Landlord_dotmyid: '',
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       Status_dotmyid: '202081877',
//       TMLink:
//         'http:20912001781201cwhome1html?page=taskmanager&topParentName=New Retail Restaurant Space For Lease - Twin Falls&topParentID=41476&tm_style=__due&cmd=&iList=Property&formID=243881000044443629&formMyID=41476&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-1',
//       cmd: '',
//       myID: 41476,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     }
//   ]
// }
// / /////////////////////////////////==
// let PropertiesSTATICtwo = {
//   Properties: [
//     {
//       Added_Time: '05-01-18 14:31:44',
//       Added_User: 'shannon.hull1',
//       Address: 'Gateway Marketplace  , Meridian, ID, 83646',
//       Address1: 'Gateway Marketplace ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       Building_SpaceDOTBuilding_Space: ['2902', '2970', '3004', '3036'],
//       City: 'Meridian',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059766050,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:07',
//       Modified_User: 'ensobase',
//       Name: 'Gateway Marketplace ',
//       Notes: '2902 - Pinnacle Lockbox: 012. Tammy got on 050118',
//       Parcel_Number: '',
//       ParentID: '',
//       Seller_Landlord: ['Relo Boise, LLC '],
//       Seller_LandlordDOTmyID: [758900427],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Gateway Marketplace &topParentID=758879194&tm_style=__due&cmd=&iList=Property&formID=243881000059766036&formMyID=758879194&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Multi-Tenant',
//       Zip_Postal_Code: '83646',
//       Zoning: '',
//       cmd: 'newFromHomeIcon',
//       myID: 758879194,
//       subFormAction: '',
//       touch: '',
//       touchOther: ''
//     },
//     {
//       Added_Time: '04-19-18 10:36:26',
//       Added_User: 'shannon.hull1',
//       Address: '9998-10070-10032 W. State St. , Boise, ID, 83714',
//       Address1: '9998-10070-10032 W. State St. ',
//       Address2: '',
//       Asking_Price: ' 490,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059708060,
//       Land_Size_Acres: 1.31,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:06',
//       Modified_User: 'ensobase',
//       Name: 'Jacksons - State Street Parcels',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 708043775,
//       Seller_Landlord: ['DFC Investments Limited Partnership '],
//       Seller_LandlordDOTmyID: [708107454],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Jacksons - State Street Parcels&topParentID=708043775&tm_style=__due&cmd=&iList=Property&formID=243881000059708072&formMyID=708043775&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Land',
//       Zip_Postal_Code: '83714',
//       Zoning: '',
//       cmd: 'newFromHomeIcon',
//       myID: 708043775,
//       subFormAction: '',
//       touch: '04-19-18',
//       touchOther: '04-19-18'
//     },
//     {
//       Added_Time: '04-10-18 15:01:40',
//       Added_User: 'shannon.hull1',
//       Address: '770 W Ustick Rd. , Meridian, ID, 83646',
//       Address1: '770 W Ustick Rd. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Meridian ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059655040,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:06',
//       Modified_User: 'ensobase',
//       Name: 'Jacksons - Ustick ',
//       Notes:
//         'Here’s the store contact info:\n168 - Ustick & Venable \nChevron - District 4\n710 W. Ustick Rd.\nMeridian, ID 83642\n208-888-8788\nManager: Johnny Gamboa \n\n \n\n \n',
//       Parcel_Number: '',
//       ParentID: 946336877,
//       Seller_Landlord: [
//         'Jacksons Food Stores- Inc.  Jacksons Food Stores- Inc.'
//       ],
//       Seller_LandlordDOTmyID: [275458660],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Jacksons - Ustick &topParentID=946336877&tm_style=__due&cmd=&iList=Property&formID=243881000059655034&formMyID=946336877&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83646',
//       Zoning: '',
//       cmd: '',
//       myID: 946336877,
//       subFormAction: '',
//       touch: '04-10-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '04-09-18 11:31:25',
//       Added_User: 'sara.shropshire1',
//       Address: '404 S. 8th St. Suite L120 , Boise, ID, 83702',
//       Address1: '404 S. 8th St. Suite L120',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 7144,
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059652030,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:06',
//       Modified_User: 'ensobase',
//       Name: 'Cafe Ole',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 847295352,
//       Seller_Landlord: ['Ephraim Greenwall '],
//       Seller_LandlordDOTmyID: [847354026],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Cafe Ole&topParentID=847295352&tm_style=__due&cmd=&iList=Property&formID=243881000059652034&formMyID=847295352&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Inline',
//       Zip_Postal_Code: '83702',
//       Zoning: '',
//       cmd: 'newFromHomeIcon',
//       myID: 847295352,
//       subFormAction: '',
//       touch: '04-09-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '04-05-18 11:06:49',
//       Added_User: 'shannon.hull1',
//       Address: 'Land at UstickFranklin , Nampa, ID, 83404',
//       Address1: 'Land at UstickFranklin',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059640100,
//       Land_Size_Acres: 15,
//       Modified_Time: '05-03-18 00:00:06',
//       Modified_User: 'ensobase',
//       Name: 'Jacksons - Land-UstickFranklin',
//       Notes: '',
//       Parcel_Number: 'R3078201000',
//       ParentID: 500226010,
//       Seller_Landlord: ['JRL Properties- L.P. and Glasgow Enterprises- LLC '],
//       Seller_LandlordDOTmyID: [500300700],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Jacksons - Land-UstickFranklin&topParentID=500226010&tm_style=__due&cmd=&iList=Property&formID=243881000059640097&formMyID=500226010&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Land',
//       Zip_Postal_Code: '83404',
//       Zoning: '',
//       cmd: '',
//       myID: 500226010,
//       subFormAction: '',
//       touch: '04-05-18',
//       touchOther: '04-05-18'
//     },
//     {
//       Added_Time: '04-05-18 08:23:51',
//       Added_User: 'shannon.hull1',
//       Address: '1260 E. 17th St. , Idaho Falls, ID, 83404',
//       Address1: '1260 E. 17th St.',
//       Address2: '',
//       Asking_Price: ' 355,000.00',
//       Building_Size_SqFt: '',
//       City: 'Idaho Falls ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059639040,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:06',
//       Modified_User: 'ensobase',
//       Name: 'Juniper Hills ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 490526529,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Juniper Hills &topParentID=490526529&tm_style=__due&cmd=&iList=Property&formID=243881000059639036&formMyID=490526529&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Land',
//       Zip_Postal_Code: '83404',
//       Zoning: '',
//       cmd: '',
//       myID: 490526529,
//       subFormAction: '',
//       touch: '04-05-18',
//       touchOther: '04-05-18'
//     },
//     {
//       Added_Time: '03-07-18 08:18:46',
//       Added_User: 'shannon.hull1',
//       Address: '390 S. Capitol Blvd. , Boise, ID, 83702',
//       Address1: '390 S. Capitol Blvd.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 2460,
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059494300,
//       Land_Size_Acres: '',
//       Listing_Broker: [
//         'Bryan Vaughn - Hawkins Companies 855 Broad St.- Ste. 300'
//       ],
//       Listing_BrokerDOTmyID: [988141392],
//       Modified_Time: '05-03-18 00:00:06',
//       Modified_User: 'ensobase',
//       Name: 'MOD - Trader Joes Pad',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 988066379,
//       Seller_Landlord: ['FAE Holdings 415776R LLC '],
//       Seller_LandlordDOTmyID: [988102055],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=MOD - Trader Joes Pad&topParentID=988066379&tm_style=__due&cmd=&iList=Property&formID=243881000059494294&formMyID=988066379&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83702',
//       Zoning: '',
//       cmd: '',
//       myID: 988066379,
//       subFormAction: '',
//       touch: '03-07-18',
//       touchOther: '04-04-18'
//     },
//     {
//       Added_Time: '03-02-18 14:20:46',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059468130,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:06',
//       Modified_User: 'ensobase',
//       Name: 'TSC - Eagle and McMillan',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 578036023,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=TSC - Eagle and McMillan&topParentID=578036023&tm_style=__due&cmd=&iList=Property&formID=243881000059468143&formMyID=578036023&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: 'newFromHomeIcon',
//       myID: 578036023,
//       subFormAction: '',
//       touch: '03-02-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '03-01-18 14:09:11',
//       Added_User: 'shannon.hull1',
//       Address: '1118 Main St. , Buhl, ID, 83316',
//       Address1: '1118 Main St. ',
//       Address2: '',
//       Asking_Price: ' 120,000.00',
//       Building_Size_SqFt: 12000,
//       City: 'Buhl',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059454080,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Idaho Youth Ranch - Buhl',
//       Notes: 'Area Manager Michelle Sams (208-881-6137)',
//       Parcel_Number: 'RPB7241114029A',
//       ParentID: 490809613,
//       Seller_Landlord: ['Rick Alis  Idaho Youth Ranch '],
//       Seller_LandlordDOTmyID: [840472960],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Idaho Youth Ranch - Buhl&topParentID=490809613&tm_style=__due&cmd=&iList=Property&formID=243881000059454069&formMyID=490809613&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83316',
//       Zoning: '',
//       cmd: 'newFromHomeIcon',
//       myID: 490809613,
//       subFormAction: '',
//       touch: '03-01-18',
//       touchOther: '03-14-18'
//     },
//     {
//       Added_Time: '02-26-18 13:00:39',
//       Added_User: 'shannon.hull1',
//       Address: '7025 Emerald St. , Boise, ID, 83704',
//       Address1: '7025 Emerald St. ',
//       Address2: '',
//       Asking_Price: ' 827,000.00',
//       Building_Size_SqFt: 9734,
//       City: 'Boise',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059392000,
//       Land_Size_Acres: 0.556,
//       Listing_Broker: ['Office Team  '],
//       Listing_BrokerDOTmyID: [888988244],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Idaho Youth Ranch - Emerald',
//       Notes: '6% with 3rd party broker \n4% without 3rd party broker \n\n',
//       Parcel_Number: 'S1007325550',
//       ParentID: 888945538,
//       Seller_Landlord: ['Rick Alis  Idaho Youth Ranch '],
//       Seller_LandlordDOTmyID: [840472960],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Idaho Youth Ranch - Emerald&topParentID=888945538&tm_style=__due&cmd=&iList=Property&formID=243881000059391993&formMyID=888945538&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83704',
//       Zoning: '',
//       cmd: '',
//       myID: 888945538,
//       subFormAction: '',
//       touch: '03-12-18',
//       touchOther: '03-12-18'
//     },
//     {
//       Added_Time: '02-23-18 14:27:28',
//       Added_User: 'shannon.hull1',
//       Address: '16808 N. Marketplace Blvd. , Nampa, ID, 83687',
//       Address1: '16808 N. Marketplace Blvd.',
//       Address2: '',
//       Asking_Price: ' 31.00',
//       Building_Size_SqFt: 6022,
//       City: 'Nampa',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059366300,
//       Land_Size_Acres: 0.93,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Native Grill - Nampa',
//       Notes:
//         'https:www.dropbox.comshxhw8swsc3934apjAADDs-ND4WEguy2sAJ7h6fPLa?dl=0\n\nTaxes: 32,442\nIns: 4,500\n',
//       Parcel_Number: '309711010',
//       ParentID: 973387884,
//       Seller_Landlord: [
//         'Charles Adam - 16808 Marketplace- LLC 16808 Marketplace- LLC'
//       ],
//       Seller_LandlordDOTmyID: [973562743],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Native Grill - Nampa&topParentID=973387884&tm_style=__due&cmd=&iList=Property&formID=243881000059366311&formMyID=973387884&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83687',
//       Zoning: '',
//       cmd: '',
//       myID: 973387884,
//       subFormAction: '',
//       touch: '03-14-18',
//       touchOther: '04-04-18'
//     },
//     {
//       Added_Time: '02-23-18 13:41:14',
//       Added_User: 'shannon.hull1',
//       Address: '2882 N. Eagle Rd. , Meridian, ID, 83646',
//       Address1: '2882 N. Eagle Rd. ',
//       Address2: '',
//       Asking_Price: ' 5,000,000.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059366180,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Norco ',
//       Notes: 'Norco will be out late May, early June',
//       Parcel_Number: '',
//       ParentID: 970762629,
//       Seller_Landlord: [
//         'Jim A. Kissler- LLC KISSLER ENTERPRISES LIMITED PARTNERSHIP'
//       ],
//       Seller_LandlordDOTmyID: [289674101],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Norco &topParentID=970762629&tm_style=__due&cmd=&iList=Property&formID=243881000059366190&formMyID=970762629&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83646',
//       Zoning: '',
//       cmd: '',
//       myID: 970762629,
//       subFormAction: '',
//       touch: '03-07-18',
//       touchOther: '03-07-18'
//     },
//     {
//       Added_Time: '02-23-18 11:17:41',
//       Added_User: 'shannon.hull1',
//       Address: 'Sunnyside & Hitt (SEC South 25th East) , Ammon, ID, 83406',
//       Address1: 'Sunnyside & Hitt (SEC South 25th East)',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 2824,
//       City: 'Ammon',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059366000,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Brent Wilson Thornton Oliver Keller'],
//       Listing_BrokerDOTmyID: [289669846],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'MOD - Sandcreek Commons - Ammon',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 961468679,
//       Seller_Landlord: ['Sandcreek Commons LLC '],
//       Seller_LandlordDOTmyID: [961629655],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=MOD - Sandcreek Commons - Ammon&topParentID=961468679&tm_style=__due&cmd=&iList=Property&formID=243881000059366015&formMyID=961468679&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83406',
//       Zoning: '',
//       cmd: '',
//       myID: 961468679,
//       subFormAction: '',
//       touch: '02-23-18',
//       touchOther: '02-23-18'
//     },
//     {
//       Added_Time: '02-20-18 13:24:23',
//       Added_User: 'shannon.hull1',
//       Address: '62 W. Bridge St. , Blackfoot, ID, 83221',
//       Address1: '62 W. Bridge St. ',
//       Address2: '',
//       Asking_Price: ' 170,000.00',
//       Building_Size_SqFt: 23018,
//       City: 'Blackfoot ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059336130,
//       Land_Size_Acres: 0.502,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Idaho Youth Ranch - Blackfoot',
//       Notes:
//         'Sale = 6% with 3rd party broker - 4% without 3rd party broker \nClose?\nArea Manager Michelle Sams (208-881-6137)\nLockbox = 1150',
//       Parcel_Number: 'RP1013101',
//       ParentID: 288945538,
//       Seller_Landlord: ['Rick Alis  Idaho Youth Ranch '],
//       Seller_LandlordDOTmyID: [840472960],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Idaho Youth Ranch - Blackfoot&topParentID=288945538&tm_style=__due&cmd=&iList=Property&formID=243881000059336113&formMyID=288945538&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83221',
//       Zoning: '',
//       cmd: '',
//       myID: 288945538,
//       subFormAction: '',
//       touch: '03-28-18',
//       touchOther: '03-28-18'
//     },
//     {
//       Added_Time: '02-20-18 10:59:11',
//       Added_User: 'shannon.hull1',
//       Address: '3840 W. Chinden Blvd. , Garden City, ID, 83714',
//       Address1: '3840 W. Chinden Blvd.',
//       Address2: '',
//       Asking_Price: ' 700,000.00',
//       Building_Size_SqFt: 14810,
//       City: 'Garden City ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059336060,
//       Land_Size_Acres: 0.713,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '04-17-18 16:08:56',
//       Modified_User: 'shannon.hull1',
//       Name: 'Idaho Youth Ranch - Chinden',
//       Notes:
//         'Sale = 6% with 3rd party broker - 4% without 3rd party broker \n\nClose when it sells\n\nArea Manager Robin Glenn (208-713-2936)',
//       Parcel_Number: '',
//       ParentID: 388945538,
//       Seller_Landlord: ['Rick Alis  Idaho Youth Ranch '],
//       Seller_LandlordDOTmyID: [840472960],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Idaho Youth Ranch - Chinden&topParentID=388945538&tm_style=__due&cmd=&iList=Property&formID=243881000059336065&formMyID=388945538&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83714',
//       Zoning: '',
//       cmd: '',
//       myID: 388945538,
//       subFormAction: '',
//       touch: '04-17-18',
//       touchOther: '04-17-18'
//     },
//     {
//       Added_Time: '02-20-18 10:57:24',
//       Added_User: 'shannon.hull1',
//       Address: '129 East Main St. , Emmett, ID, 83617',
//       Address1: '129 East Main St.',
//       Address2: '',
//       Asking_Price: ' 210,000.00',
//       Building_Size_SqFt: 12972,
//       City: 'Emmett',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059336030,
//       Land_Size_Acres: 0.161,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Idaho Youth Ranch - Emmett',
//       Notes:
//         '6% with 3rd party broker \n4% without 3rd party broker \n\nClose in June\n\nContact Area Mgr Rebecca Cole (208-422-4124)',
//       Parcel_Number: 'RPE32100030108',
//       ParentID: 188945538,
//       Seller_Landlord: ['Rick Alis  Idaho Youth Ranch '],
//       Seller_LandlordDOTmyID: [840472960],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Idaho Youth Ranch - Emmett&topParentID=188945538&tm_style=__due&cmd=&iList=Property&formID=243881000059336039&formMyID=188945538&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83617',
//       Zoning: '',
//       cmd: '',
//       myID: 188945538,
//       subFormAction: '',
//       touch: '03-12-18',
//       touchOther: '01-30-18'
//     },
//     {
//       Added_Time: '02-16-18 13:31:43',
//       Added_User: 'shannon.hull1',
//       Address: '1509 N. 13th St. , Boise, ID, 83702',
//       Address1: '1509 N. 13th St. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059323200,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Bier Thirty - 1509 13th ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 365244259,
//       Seller_Landlord: ['KOA RE IV SC '],
//       Seller_LandlordDOTmyID: [365276235],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Bier Thirty - 1509 13th &topParentID=365244259&tm_style=__due&cmd=&iList=Property&formID=243881000059323214&formMyID=365244259&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83702',
//       Zoning: '',
//       cmd: '',
//       myID: 365244259,
//       subFormAction: '',
//       touch: '03-07-18',
//       touchOther: '03-07-18'
//     },
//     {
//       Added_Time: '02-13-18 08:38:12',
//       Added_User: 'shannon.hull1',
//       Address: '11081110 W. Jefferson St.  , Boise, ID, 83702',
//       Address1: '11081110 W. Jefferson St. ',
//       Address2: '',
//       Asking_Price: ' 1,000,000.00',
//       Building_Size_SqFt: 3100,
//       City: 'Boise',
//       Deal_Type: ['Sale', 'Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059293020,
//       Land_Size_Acres: 0.14,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Chandi',
//       Notes:
//         'https:www.dropbox.comshwru3emh2q7m9od0AACbZmO-xJASpSdtx4R_ucu0a?dl=0\n',
//       Parcel_Number: 'R1013004616R1013004611',
//       ParentID: 87623929,
//       Seller_Landlord: ['11th & Jefferson LLC '],
//       Seller_LandlordDOTmyID: [87775681],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Chandi&topParentID=87623929&tm_style=__due&cmd=&iList=Property&formID=243881000059293027&formMyID=87623929&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83702',
//       Zoning: 'C-5DD',
//       cmd: '',
//       myID: 87623929,
//       subFormAction: '',
//       touch: '02-23-18',
//       touchOther: '03-12-18'
//     },
//     {
//       Added_Time: '02-06-18 10:10:26',
//       Added_User: 'shannon.hull1',
//       Address: '10346-10500 W. Overland , Boise, ID, 83709',
//       Address1: '10346-10500 W. Overland ',
//       Address2: '',
//       Asking_Price: ' 16,655,000.00',
//       Building_Size_SqFt: '',
//       Building_SpaceDOTBuilding_Space: ['&nbsp;'],
//       City: 'Boise',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059255550,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: '5 Mile Plaza ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 489133769,
//       Seller_Landlord: ['BDC 5 Mile Plaza L.P. '],
//       Seller_LandlordDOTmyID: [489209028],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=5 Mile Plaza &topParentID=489133769&tm_style=__due&cmd=&iList=Property&formID=243881000059255555&formMyID=489133769&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Investment',
//       Zip_Postal_Code: '83709',
//       Zoning: '',
//       cmd: '',
//       myID: 489133769,
//       subFormAction: '',
//       touch: '02-15-18',
//       touchOther: '02-23-18'
//     },
//     {
//       Added_Time: '02-06-18 09:00:08',
//       Added_User: 'shannon.hull1',
//       Address: '6195 S. Five Mile Rd. , Boise, ID, 83709',
//       Address1: '6195 S. Five Mile Rd. ',
//       Address2: '',
//       Asking_Price: ' 6,304,761.00',
//       Building_Size_SqFt: 14820,
//       City: 'Boise',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000059255420,
//       Land_Size_Acres: 1.74,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '03-28-18 13:41:15',
//       Modified_User: 'shannon.hull1',
//       Name: 'Walgreens - Five Mile ',
//       Notes: '',
//       Parcel_Number: 'S1134449021',
//       ParentID: 485062683,
//       Seller_Landlord: ['Gary Pickett M. H. Sherman Company '],
//       Seller_LandlordDOTmyID: [485096007],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Walgreens - Five Mile &topParentID=485062683&tm_style=__due&cmd=&iList=Property&formID=243881000059255429&formMyID=485062683&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Investment',
//       Zip_Postal_Code: '83709',
//       Zoning: '',
//       cmd: '',
//       myID: 485062683,
//       subFormAction: '',
//       touch: '03-28-18',
//       touchOther: '03-28-18'
//     },
//     {
//       Added_Time: '01-25-18 15:33:41',
//       Added_User: 'sara.shropshire1',
//       Address: '1099 Blue Lakes , Twin Falls, Idaho, 83301',
//       Address1: '1099 Blue Lakes',
//       Address2: '',
//       Asking_Price: ' 750,000.00',
//       Building_Size_SqFt: 2686,
//       City: 'Twin Falls',
//       Deal_Type: ['Sale', 'Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058846100,
//       Land_Size_Acres: 0.64,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Twin Falls Pizza Hut',
//       Notes: '',
//       Parcel_Number: 'RPT2301003001DA',
//       ParentID: 471735522,
//       Seller_Landlord: ['Allan Humphries W &H- LLC & PHI LLC'],
//       Seller_LandlordDOTmyID: [655831554],
//       Space_SF: '',
//       State_Province: 'Idaho',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Twin Falls Pizza Hut&topParentID=471735522&tm_style=__due&cmd=&iList=Property&formID=243881000058846123&formMyID=471735522&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83301',
//       Zoning: 'C1',
//       cmd: 'newFromHomeIcon',
//       myID: 471735522,
//       subFormAction: '',
//       touch: '01-25-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '01-17-18 10:10:22',
//       Added_User: 'shannon.hull1',
//       Address: '2964 Addison Ave. E. , Twin Falls, ID, 83301',
//       Address1: '2964 Addison Ave. E. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Twin Falls ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058807000,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'D & B Supply',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 761360506,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=D & B Supply&topParentID=761360506&tm_style=__due&cmd=&iList=Property&formID=243881000058807003&formMyID=761360506&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83301',
//       Zoning: '',
//       cmd: '',
//       myID: 761360506,
//       subFormAction: '',
//       touch: '01-17-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '01-17-18 10:08:02',
//       Added_User: 'shannon.hull1',
//       Address: '575 E. Franklin Rd. , Meridian, ID, 83642',
//       Address1: '575 E. Franklin Rd. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058805120,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'WAFED - Meridian',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 761235415,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=WAFED - Meridian&topParentID=761235415&tm_style=__due&cmd=&iList=Property&formID=243881000058805136&formMyID=761235415&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83642',
//       Zoning: '',
//       cmd: '',
//       myID: 761235415,
//       subFormAction: '',
//       touch: '01-17-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '01-17-18 10:03:56',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058805100,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Hope Ave.',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 761018834,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Hope Ave.&topParentID=761018834&tm_style=__due&cmd=&iList=Property&formID=243881000058805099&formMyID=761018834&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 761018834,
//       subFormAction: '',
//       touch: '01-17-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '01-03-18 16:24:09',
//       Added_User: 'shannon.hull1',
//       Address: ' , Nampa, ID, ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Nampa ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058715040,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'BBW - Treasure Valley Marketplace',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 574028352,
//       Seller_Landlord: ['TVM CenterCal- LLC  '],
//       Seller_LandlordDOTmyID: [574057840],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=BBW - Treasure Valley Marketplace&topParentID=574028352&tm_style=__due&cmd=&iList=Property&formID=243881000058715032&formMyID=574028352&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 574028352,
//       subFormAction: '',
//       touch: '01-03-18',
//       touchOther: '01-03-18'
//     },
//     {
//       Added_Time: '12-19-17 13:49:17',
//       Added_User: 'shannon.hull1',
//       Address: '406-410-414-418 Oneida St. , Rupert, ID, 83350',
//       Address1: '406-410-414-418 Oneida St. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 9060,
//       City: 'Rupert ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058658850,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Dollar Tree - Rupert',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 268852765,
//       Seller_Landlord: ['CJM LP '],
//       Seller_LandlordDOTmyID: [469715950],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Dollar Tree - Rupert&topParentID=268852765&tm_style=__due&cmd=&iList=Property&formID=243881000058658850&formMyID=268852765&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83350',
//       Zoning: '',
//       cmd: 'newFromHomeIcon',
//       myID: 268852765,
//       subFormAction: '',
//       touch: '12-19-17',
//       touchOther: '03-07-18'
//     },
//     {
//       Added_Time: '12-19-17 09:30:27',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Sale', 'Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058658200,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Ten Mile and McMillan (NEC)',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 253202749,
//       Seller_Landlord: [
//         'Prime Desert Properties- LLC - Nagarjun Reddy Yarapu  Prime Desert Properties- LLC'
//       ],
//       Seller_LandlordDOTmyID: [253254084],
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Ten Mile and McMillan (NEC)&topParentID=253202749&tm_style=__due&cmd=&iList=Property&formID=243881000058658209&formMyID=253202749&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 253202749,
//       subFormAction: '',
//       touch: '12-19-17',
//       touchOther: '02-15-18'
//     },
//     {
//       Added_Time: '12-13-17 13:10:44',
//       Added_User: 'shannon.hull1',
//       Address: '5033 W. State St. , Boise, ID, 83703',
//       Address1: '5033 W. State St. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058581730,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Brianna Miller - TOK '],
//       Listing_BrokerDOTmyID: [287648231],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Zen Bento - Lake Harbor ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 748043355,
//       Seller_Landlord: ['Idaho Mortgage Program LLC  '],
//       Seller_LandlordDOTmyID: [995657915],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Zen Bento - Lake Harbor &topParentID=748043355&tm_style=__due&cmd=&iList=Property&formID=243881000058581720&formMyID=748043355&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83703',
//       Zoning: '',
//       cmd: '',
//       myID: 748043355,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-08-17 09:08:14',
//       Added_User: 'shannon.hull1',
//       Address: '1350 Parkway Dr., Space 2728 , Blackfoot, ID, 83221',
//       Address1: '1350 Parkway Dr., Space 2728',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Blackfoot',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058565200,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Sean Williams  Woodbury Corp'],
//       Listing_BrokerDOTmyID: [301591655],
//       Modified_Time: '12-08-17 10:35:50',
//       Modified_User: 'ensobase',
//       Name: 'Dollar Tree - Blackfoot',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 301503654,
//       Seller_Landlord: ['Riverside Plaza Shopping Center '],
//       Seller_LandlordDOTmyID: [301559866],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Dollar Tree - Blackfoot&topParentID=301503654&tm_style=__due&cmd=&iList=Property&formID=243881000058565189&formMyID=301503654&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83221',
//       Zoning: '',
//       cmd: '',
//       myID: 301503654,
//       subFormAction: '',
//       touch: '12-08-17',
//       touchOther: '12-08-17'
//     },
//     {
//       Added_Time: '12-06-17 09:29:01',
//       Added_User: 'shannon.hull1',
//       Address: '163 Houston Circle , Idaho Falls, ID, 83402',
//       Address1: '163 Houston Circle ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Idaho Falls ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058468220,
//       Land_Size_Acres: '',
//       Modified_Time: '03-07-18 08:01:32',
//       Modified_User: 'shannon.hull1',
//       Name: 'Upward Ventures LLC - Idaho Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 130097815,
//       Seller_Landlord: ['Renaissance Partners- LLP '],
//       Seller_LandlordDOTmyID: [130114447],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Lease',
//       StatusDOTmyID: '144662939',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Upward Ventures LLC - Idaho Falls&topParentID=130097815&tm_style=__due&cmd=&iList=Property&formID=243881000058468225&formMyID=130097815&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83402',
//       Zoning: '',
//       cmd: '',
//       myID: 130097815,
//       subFormAction: '',
//       touch: '03-07-18',
//       touchOther: '03-07-18'
//     },
//     {
//       Added_Time: '12-05-17 12:49:41',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058448600,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Greenstone ',
//       Notes: 'Need to start working on leasing soon',
//       Parcel_Number: '',
//       ParentID: 55737075,
//       Seller_Landlord: ['HBCBP- LLC  '],
//       Seller_LandlordDOTmyID: [464791540],
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Greenstone &topParentID=55737075&tm_style=__due&cmd=&iList=Property&formID=243881000058448609&formMyID=55737075&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 55737075,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-05-17 12:48:13',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058448600,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Scott Tarbet - Nampa DDR',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 55656014,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Scott Tarbet - Nampa DDR&topParentID=55656014&tm_style=__due&cmd=&iList=Property&formID=243881000058448595&formMyID=55656014&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 55656014,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-05-17 12:47:21',
//       Added_User: 'shannon.hull1',
//       Address: '3197 N. Cole Rd. , Boise, ID, 83704',
//       Address1: '3197 N. Cole Rd. ',
//       Address2: '',
//       Asking_Price: ' 530,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058448580,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'WAFED - Ustick-Cole',
//       Notes: '6% commission',
//       Parcel_Number: '',
//       ParentID: 55626959,
//       Seller_Landlord: ['Keith Taylor - WAFED Washington Federal '],
//       Seller_LandlordDOTmyID: [910924950],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=WAFED - Ustick-Cole&topParentID=55626959&tm_style=__due&cmd=&iList=Property&formID=243881000058448581&formMyID=55626959&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83704',
//       Zoning: '',
//       cmd: '',
//       myID: 55626959,
//       subFormAction: '',
//       touch: '12-27-17',
//       touchOther: '12-27-17'
//     },
//     {
//       Added_Time: '12-05-17 12:46:56',
//       Added_User: 'shannon.hull1',
//       Address: '223 11th Ave. S. , Nampa, ID, 83605',
//       Address1: '223 11th Ave. S. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058448580,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '03-07-18 08:33:25',
//       Modified_User: 'shannon.hull1',
//       Name: 'WAFED - Nampa ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 55590429,
//       Seller_Landlord: ['Ricka Gerstmann Washington Federal'],
//       Seller_LandlordDOTmyID: [289674319],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=WAFED - Nampa &topParentID=55590429&tm_style=__due&cmd=&iList=Property&formID=243881000058448567&formMyID=55590429&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83605',
//       Zoning: '',
//       cmd: '',
//       myID: 55590429,
//       subFormAction: '',
//       touch: '02-06-18',
//       touchOther: '03-07-18'
//     },
//     {
//       Added_Time: '12-05-17 12:45:57',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058448540,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'WAFED - Caldwell',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 55463615,
//       Seller_Landlord: ['Ricka Gerstmann Washington Federal'],
//       Seller_LandlordDOTmyID: [289674319],
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=WAFED - Caldwell&topParentID=55463615&tm_style=__due&cmd=&iList=Property&formID=243881000058448553&formMyID=55463615&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 55463615,
//       subFormAction: '',
//       touch: '12-14-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-05-17 12:34:15',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058448500,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Sherwin Williams - Twin Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 54836953,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Sherwin Williams - Twin Falls&topParentID=54836953&tm_style=__due&cmd=&iList=Property&formID=243881000058448508&formMyID=54836953&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 54836953,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-05-17 12:31:05',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058448480,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Culvers',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 54648095,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Culvers&topParentID=54648095&tm_style=__due&cmd=&iList=Property&formID=243881000058448486&formMyID=54648095&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 54648095,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-05-17 12:29:57',
//       Added_User: 'shannon.hull1',
//       Address: 'Hwy 16 and Beacon , Eagle, ID, 83616',
//       Address1: 'Hwy 16 and Beacon',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Eagle ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058448450,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '02-06-18 08:55:24',
//       Modified_User: 'shannon.hull1',
//       Name: 'ABS - Hwy 16 and Beacon',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 54550481,
//       Seller_Landlord: ["Albertson's "],
//       Seller_LandlordDOTmyID: [636408149],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=ABS - Hwy 16 and Beacon&topParentID=54550481&tm_style=__due&cmd=&iList=Property&formID=243881000058448461&formMyID=54550481&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83616',
//       Zoning: '',
//       cmd: '',
//       myID: 54550481,
//       subFormAction: '',
//       touch: '02-06-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-05-17 12:22:41',
//       Added_User: 'shannon.hull1',
//       Address: '950 W. Bannock St., Ste. 100 , Boise, ID, 83702',
//       Address1: '950 W. Bannock St., Ste. 100',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058448350,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Banner Bank - Downtown ',
//       Notes: 'Andrea to follow-up with Carl after New Year ',
//       Parcel_Number: '',
//       ParentID: 54104354,
//       Seller_Landlord: ['T&B Land Holding LLC '],
//       Seller_LandlordDOTmyID: [996448061],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Banner Bank - Downtown &topParentID=54104354&tm_style=__due&cmd=&iList=Property&formID=243881000058448345&formMyID=54104354&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Investment',
//       Zip_Postal_Code: '83702',
//       Zoning: '',
//       cmd: '',
//       myID: 54104354,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-05-17 12:07:53',
//       Added_User: 'shannon.hull1',
//       Address: '611 12th Ave. Rd. , Nampa, ID, 83686',
//       Address1: '611 12th Ave. Rd. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 2332,
//       City: 'Nampa',
//       Deal_Type: ['Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058448060,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Arbys - 12th Ave.',
//       Notes: "Anticipated opening date for Arby's = 042318",
//       Parcel_Number: '',
//       ParentID: 52946330,
//       Seller_Landlord: ['Gerald Waller  W &H- LLC & PHI LLC'],
//       Seller_LandlordDOTmyID: [909850128],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Arbys - 12th Ave.&topParentID=52946330&tm_style=__due&cmd=&iList=Property&formID=243881000058448080&formMyID=52946330&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Investment',
//       Zip_Postal_Code: '83686',
//       Zoning: '',
//       cmd: '',
//       myID: 52946330,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: '04-16-18'
//     },
//     {
//       Added_Time: '12-04-17 11:28:39',
//       Added_User: 'shannon.hull1',
//       Address: '1111 Broadway , Boise, ID, 83706',
//       Address1: '1111 Broadway',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058426180,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Scott Raeber- CCIM- MBA Colliers'],
//       Listing_BrokerDOTmyID: [289671565],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'TSC - Broadway',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 964507687,
//       Seller_Landlord: ['Futureworks LLC  '],
//       Seller_LandlordDOTmyID: [995166852],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=TSC - Broadway&topParentID=964507687&tm_style=__due&cmd=&iList=Property&formID=243881000058426183&formMyID=964507687&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83706',
//       Zoning: '',
//       cmd: '',
//       myID: 964507687,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 11:27:55',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058426180,
//       Land_Size_Acres: '',
//       Modified_Time: '02-06-18 08:55:53',
//       Modified_User: 'shannon.hull1',
//       Name: 'Top Golf ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 964467542,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Top Golf &topParentID=964467542&tm_style=__due&cmd=&iList=Property&formID=243881000058426163&formMyID=964467542&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 964467542,
//       subFormAction: '',
//       touch: '02-06-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 11:27:41',
//       Added_User: 'shannon.hull1',
//       Address: '5001 N. 10 Mile , Meridian, ID, 83646',
//       Address1: '5001 N. 10 Mile ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 2200,
//       City: 'Meridian',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058426140,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Darin Burrell Idaho Commercial Brokerage'],
//       Listing_BrokerDOTmyID: [289670115],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Starbucks - Ten Mile-McMillan',
//       Notes: 'Panda Plaza Shopping Center ',
//       Parcel_Number: '',
//       ParentID: 964446443,
//       Seller_Landlord: ['CFT NV Developments- LLC - Charlie Shen '],
//       Seller_LandlordDOTmyID: [994459736],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Starbucks - Ten Mile-McMillan&topParentID=964446443&tm_style=__due&cmd=&iList=Property&formID=243881000058426143&formMyID=964446443&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83646',
//       Zoning: '',
//       cmd: '',
//       myID: 964446443,
//       subFormAction: '',
//       touch: '04-05-18',
//       touchOther: '04-05-18'
//     },
//     {
//       Added_Time: '12-04-17 11:27:19',
//       Added_User: 'shannon.hull1',
//       Address: '4622 N. Eagle Rd. , Boise, ID, 83713',
//       Address1: '4622 N. Eagle Rd. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 1750,
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058426100,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Starbucks - Eagle-McMillan - Sublease',
//       Notes:
//         'Lockbox code = 3040\n\nSubalese. sbx lease ends 2272022 NNN 7.80\nRestrictions- Cell phone, bank, financial, Pizza, bakery, bar, adult stuff\n\nhttps:www.dropbox.comshubac74ke3zci5neAACNVTTUAflCLfjwtnkeOP-ja?dl=0\n',
//       Parcel_Number: '',
//       ParentID: 964425598,
//       Seller_Landlord: ['Starbucks - Jennifer Geoffroy  Starbucks Corporation'],
//       Seller_LandlordDOTmyID: [677065323],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Starbucks - Eagle-McMillan - Sublease&topParentID=964425598&tm_style=__due&cmd=&iList=Property&formID=243881000058426123&formMyID=964425598&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Endcap',
//       Zip_Postal_Code: '83713',
//       Zoning: '',
//       cmd: '',
//       myID: 964425598,
//       subFormAction: '',
//       touch: '04-18-18',
//       touchOther: '03-20-18'
//     },
//     {
//       Added_Time: '12-04-17 11:26:56',
//       Added_User: 'shannon.hull1',
//       Address: '110 N. 8th St., Ste. 100 , Boise, ID, 83702',
//       Address1: '110 N. 8th St., Ste. 100',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058426100,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Starbucks - Capital Terrace',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 964396487,
//       Seller_Landlord: ['Beau Manwaring  Hawkins Companies- LLC'],
//       Seller_LandlordDOTmyID: [992669207],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Starbucks - Capital Terrace&topParentID=964396487&tm_style=__due&cmd=&iList=Property&formID=243881000058426103&formMyID=964396487&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83702',
//       Zoning: '',
//       cmd: '',
//       myID: 964396487,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 11:26:07',
//       Added_User: 'shannon.hull1',
//       Address: '1480 W. Chinden Blvd. , Meridian, ID, 83646',
//       Address1: '1480 W. Chinden Blvd.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058426080,
//       Land_Size_Acres: 0.881,
//       Listing_Broker: ['Mark Bottles Mark Bottles Real Estate Services Llc'],
//       Listing_BrokerDOTmyID: [289671008],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Starbucks - Chinden-Linder ',
//       Notes: '',
//       Parcel_Number: 'R5176900500',
//       ParentID: 964348560,
//       Seller_Landlord: ['Eisenberg Linchin LLC '],
//       Seller_LandlordDOTmyID: [993224219],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Starbucks - Chinden-Linder &topParentID=964348560&tm_style=__due&cmd=&iList=Property&formID=243881000058426077&formMyID=964348560&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83646',
//       Zoning: '',
//       cmd: '',
//       myID: 964348560,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 11:25:07',
//       Added_User: 'shannon.hull1',
//       Address: '2809 Cleveland Blvd. , Caldwell, ID, ',
//       Address1: '2809 Cleveland Blvd. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058426050,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Rite Aid - Caldwell',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 964184677,
//       Seller_Landlord: ['Buffalo Bal Business  '],
//       Seller_LandlordDOTmyID: [964249691],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Rite Aid - Caldwell&topParentID=964184677&tm_style=__due&cmd=&iList=Property&formID=243881000058426057&formMyID=964184677&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 964184677,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 11:22:29',
//       Added_User: 'shannon.hull1',
//       Address: '530 N. 2nd E. , Rexburg, ID, 83440',
//       Address1: '530 N. 2nd E. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Rexburg ',
//       Deal_Type: ['Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058426020,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Walmart - Rexburg - Emmett Partners',
//       Notes: 'Sale price 3.6 million',
//       Parcel_Number: '',
//       ParentID: 964084878,
//       Seller_Landlord: ['Emmett Partners- LLC - Jeremy Terry Emmett Partners'],
//       Seller_LandlordDOTmyID: [379400699],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Walmart - Rexburg - Emmett Partners&topParentID=964084878&tm_style=__due&cmd=&iList=Property&formID=243881000058426021&formMyID=964084878&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Investment',
//       Zip_Postal_Code: '83440',
//       Zoning: '',
//       cmd: '',
//       myID: 964084878,
//       subFormAction: '',
//       touch: '03-27-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 11:17:43',
//       Added_User: 'shannon.hull1',
//       Address: '8489 W. Overland Rd. , Boise, ID, 83709',
//       Address1: '8489 W. Overland Rd. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058424000,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Ponderosa Plaza ',
//       Notes: 'JK is marketing ',
//       Parcel_Number: '',
//       ParentID: 963664617,
//       Seller_Landlord: ['Idaho Land Company LLC '],
//       Seller_LandlordDOTmyID: [963758348],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Ponderosa Plaza &topParentID=963664617&tm_style=__due&cmd=&iList=Property&formID=243881000058423995&formMyID=963664617&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83709',
//       Zoning: '',
//       cmd: '',
//       myID: 963664617,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 11:13:56',
//       Added_User: 'shannon.hull1',
//       Address: '163 W. Main St. , Rexburg, ID, 83440',
//       Address1: '163 W. Main St. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Rexburg ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423970,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Pizza Hut - Rexburg ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 963519662,
//       Seller_Landlord: ['Gerald Waller  W &H- LLC & PHI LLC'],
//       Seller_LandlordDOTmyID: [909850128],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut - Rexburg &topParentID=963519662&tm_style=__due&cmd=&iList=Property&formID=243881000058423962&formMyID=963519662&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83440',
//       Zoning: '',
//       cmd: '',
//       myID: 963519662,
//       subFormAction: '',
//       touch: '03-29-18',
//       touchOther: '04-19-18'
//     },
//     {
//       Added_Time: '12-04-17 11:11:02',
//       Added_User: 'shannon.hull1',
//       Address: '675 Progress Ave. , Meridian, ID, 83642',
//       Address1: '675 Progress Ave.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Deal_Type: ['Sale', 'Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423940,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Pizza Hut - 675 Progress ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 963112462,
//       Seller_Landlord: ['Gerald Waller  W &H- LLC & PHI LLC'],
//       Seller_LandlordDOTmyID: [909850128],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut - 675 Progress &topParentID=963112462&tm_style=__due&cmd=&iList=Property&formID=243881000058423942&formMyID=963112462&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83642',
//       Zoning: '',
//       cmd: '',
//       myID: 963112462,
//       subFormAction: '',
//       touch: '01-17-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:54:38',
//       Added_User: 'shannon.hull1',
//       Address: '1553 Washington St., 102 , Twin Falls, ID, 83301',
//       Address1: '1553 Washington St., 102',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 1400,
//       City: 'Twin Falls ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423840,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Tai Biesinger  Pentad Properties '],
//       Listing_BrokerDOTmyID: [962543833],
//       Modified_Time: '12-27-17 13:33:37',
//       Modified_User: 'shannon.hull1',
//       Name: 'Pizza Hut - Cheney-Washington ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 962322001,
//       Seller_Landlord: ['HB Properties- LC '],
//       Seller_LandlordDOTmyID: [962438780],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut - Cheney-Washington &topParentID=962322001&tm_style=__due&cmd=&iList=Property&formID=243881000058423838&formMyID=962322001&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83301',
//       Zoning: '',
//       cmd: '',
//       myID: 962322001,
//       subFormAction: '',
//       touch: '12-27-17',
//       touchOther: '12-27-17'
//     },
//     {
//       Added_Time: '12-04-17 10:51:31',
//       Added_User: 'shannon.hull1',
//       Address: '1099 Blue Lakes Blvd. N. , Twin Falls, ID, 83301',
//       Address1: '1099 Blue Lakes Blvd. N. ',
//       Address2: '',
//       Asking_Price: ' 750,000.00',
//       Building_Size_SqFt: '',
//       City: 'Twin Falls ',
//       Deal_Type: ['Sale', 'Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423800,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Pizza Hut - 1099 Blue Lakes ',
//       Notes: 'Pizza Hut is expected to be out first of May',
//       Parcel_Number: '',
//       ParentID: 962162883,
//       Seller_Landlord: ['Gerald Waller  W &H- LLC & PHI LLC'],
//       Seller_LandlordDOTmyID: [909850128],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut - 1099 Blue Lakes &topParentID=962162883&tm_style=__due&cmd=&iList=Property&formID=243881000058423805&formMyID=962162883&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83301',
//       Zoning: '',
//       cmd: '',
//       myID: 962162883,
//       subFormAction: '',
//       touch: '02-20-18',
//       touchOther: '04-26-18'
//     },
//     {
//       Added_Time: '12-04-17 10:41:18',
//       Added_User: 'shannon.hull1',
//       Address: '2674-2676-2678 E. Sunnyside Rd. , Ammon, ID, ',
//       Address1: '2674-2676-2678 E. Sunnyside Rd.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Ammon',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423700,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Brent Wilson Thornton Oliver Keller'],
//       Listing_BrokerDOTmyID: [289669846],
//       Modified_Time: '01-08-18 11:40:23',
//       Modified_User: 'shannon.hull1',
//       Name: 'Orange Theory Fitness ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 961597060,
//       Seller_Landlord: ['Sandcreek Commons LLC '],
//       Seller_LandlordDOTmyID: [961629655],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Lease',
//       StatusDOTmyID: '144662939',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Orange Theory Fitness &topParentID=961597060&tm_style=__due&cmd=&iList=Property&formID=243881000058423719&formMyID=961597060&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 961597060,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: '01-08-18'
//     },
//     {
//       Added_Time: '12-04-17 10:30:43',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423680,
//       Land_Size_Acres: '',
//       Modified_Time: '12-14-17 14:42:18',
//       Modified_User: 'ensobase',
//       Name: 'Old Chicago - Chinden-Linder',
//       Notes: '2020 maybe?',
//       Parcel_Number: '',
//       ParentID: 961026697,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Old Chicago - Chinden-Linder&topParentID=961026697&tm_style=__due&cmd=&iList=Property&formID=243881000058423680&formMyID=961026697&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 961026697,
//       subFormAction: '',
//       touch: '12-13-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:29:05',
//       Added_User: 'shannon.hull1',
//       Address: '3335 N. Five Mile Rd. , Boise, ID, 83713',
//       Address1: '3335 N. Five Mile Rd.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423650,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Julie Kissler  '],
//       Listing_BrokerDOTmyID: [464758944],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Maple Tree Plaza - Five Mile',
//       Notes: 'JK Leasing',
//       Parcel_Number: '',
//       ParentID: 960909453,
//       Seller_Landlord: ['Tim Siegel - Maple Tree Holdings- LLC '],
//       Seller_LandlordDOTmyID: [996868289],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Maple Tree Plaza - Five Mile&topParentID=960909453&tm_style=__due&cmd=&iList=Property&formID=243881000058423652&formMyID=960909453&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83713',
//       Zoning: '',
//       cmd: '',
//       myID: 960909453,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:27:47',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423600,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Lolli and Pops ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 960850097,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Lolli and Pops &topParentID=960850097&tm_style=__due&cmd=&iList=Property&formID=243881000058423632&formMyID=960850097&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 960850097,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:27:21',
//       Added_User: 'shannon.hull1',
//       Address: '1555 S. Broadway Ave. , Boise, ID, 83706',
//       Address1: '1555 S. Broadway Ave.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423600,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Scott Raeber- CCIM- MBA Colliers'],
//       Listing_BrokerDOTmyID: [289671565],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Tap and Cask - Kissler ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 960801056,
//       Seller_Landlord: ['James A Kissler- LLC James A Kissler- LLC'],
//       Seller_LandlordDOTmyID: [289672189],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Tap and Cask - Kissler &topParentID=960801056&tm_style=__due&cmd=&iList=Property&formID=243881000058423618&formMyID=960801056&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83706',
//       Zoning: '',
//       cmd: '',
//       myID: 960801056,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:25:33',
//       Added_User: 'shannon.hull1',
//       Address: 'SWC Washington and Cheney , Twin Falls, ID, ',
//       Address1: 'SWC Washington and Cheney ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 1500,
//       City: 'Twin Falls',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423580,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Jersey Mikes - Twin SWC ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 960724194,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Jersey Mikes - Twin SWC &topParentID=960724194&tm_style=__due&cmd=&iList=Property&formID=243881000058423590&formMyID=960724194&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 960724194,
//       subFormAction: '',
//       touch: '04-12-18',
//       touchOther: '04-12-18'
//     },
//     {
//       Added_Time: '12-04-17 10:23:37',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423580,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Flying Pie - Florian',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 960598580,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Flying Pie - Florian&topParentID=960598580&tm_style=__due&cmd=&iList=Property&formID=243881000058423576&formMyID=960598580&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 960598580,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:23:04',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423550,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Fiiz',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 960576027,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Fiiz&topParentID=960576027&tm_style=__due&cmd=&iList=Property&formID=243881000058423562&formMyID=960576027&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 960576027,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:22:53',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423550,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Fiesta ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 960564250,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Fiesta &topParentID=960564250&tm_style=__due&cmd=&iList=Property&formID=243881000058423548&formMyID=960564250&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 960564250,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:22:35',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423520,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Stil',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 960545108,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Stil&topParentID=960545108&tm_style=__due&cmd=&iList=Property&formID=243881000058423534&formMyID=960545108&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 960545108,
//       subFormAction: '',
//       touch: '12-14-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:22:07',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Sale', 'Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423520,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Miracle Tire - Bob Andrews',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 960515316,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Miracle Tire - Bob Andrews&topParentID=960515316&tm_style=__due&cmd=&iList=Property&formID=243881000058423520&formMyID=960515316&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 960515316,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:13:35',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423360,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Bassett Furniture - Craig Werner',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 959996886,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Bassett Furniture - Craig Werner&topParentID=959996886&tm_style=__due&cmd=&iList=Property&formID=243881000058423369&formMyID=959996886&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 959996886,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:13:11',
//       Added_User: 'shannon.hull1',
//       Address: '2300 W. Fairview , Boise, ID, 83702',
//       Address1: '2300 W. Fairview ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423360,
//       Land_Size_Acres: '',
//       Modified_Time: '03-02-18 12:43:29',
//       Modified_User: 'shannon.hull1',
//       Name: '2300 W. Fairview - Tim Siegel',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 959968546,
//       Seller_Landlord: ['Robert L. Farber  '],
//       Seller_LandlordDOTmyID: [996602685],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=2300 W. Fairview - Tim Siegel&topParentID=959968546&tm_style=__due&cmd=&iList=Property&formID=243881000058423355&formMyID=959968546&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83702',
//       Zoning: '',
//       cmd: '',
//       myID: 959968546,
//       subFormAction: '',
//       touch: '03-02-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 10:12:37',
//       Added_User: 'shannon.hull1',
//       Address: '1311 12th Ave. , Nampa, , 83651',
//       Address1: '1311 12th Ave. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Nampa ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423330,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Brewers Haven ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 959892118,
//       Seller_Landlord: ['Northwest Development Companies LLC '],
//       Seller_LandlordDOTmyID: [410325239],
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Brewers Haven &topParentID=959892118&tm_style=__due&cmd=&iList=Property&formID=243881000058423341&formMyID=959892118&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83651',
//       Zoning: '',
//       cmd: '',
//       myID: 959892118,
//       subFormAction: '',
//       touch: '12-12-17',
//       touchOther: '12-12-17'
//     },
//     {
//       Added_Time: '12-04-17 10:11:25',
//       Added_User: 'shannon.hull1',
//       Address: ' , , , ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: '',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423330,
//       Land_Size_Acres: '',
//       Modified_Time: '02-06-18 08:56:14',
//       Modified_User: 'shannon.hull1',
//       Name: 'A Wireless - Dan McDonnel',
//       Notes: 'Looking for space in Pocatello, Twin, Caldwell',
//       Parcel_Number: '',
//       ParentID: 959838321,
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=A Wireless - Dan McDonnel&topParentID=959838321&tm_style=__due&cmd=&iList=Property&formID=243881000058423324&formMyID=959838321&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 959838321,
//       subFormAction: '',
//       touch: '02-06-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-04-17 08:26:00',
//       Added_User: 'shannon.hull1',
//       Address: '1799 Hurley Dr. , Pocatello, ID, 83202',
//       Address1: '1799 Hurley Dr.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 1788,
//       City: 'Pocatello',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058423040,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Don Zebe Coldwell Banker Commercial'],
//       Listing_BrokerDOTmyID: [289670361],
//       Modified_Time: '01-18-18 11:37:47',
//       Modified_User: 'shannon.hull1',
//       Name: 'Upward Ventures LLC - Pocatello',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 953356869,
//       Seller_Landlord: ['Hawks World Trade Drive- LLC  '],
//       Seller_LandlordDOTmyID: [953401116],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Upward Ventures LLC - Pocatello&topParentID=953356869&tm_style=__due&cmd=&iList=Property&formID=243881000058423049&formMyID=953356869&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83202',
//       Zoning: '',
//       cmd: '',
//       myID: 953356869,
//       subFormAction: '',
//       touch: '01-18-18',
//       touchOther: '01-18-18'
//     },
//     {
//       Added_Time: '12-01-17 13:33:24',
//       Added_User: 'shannon.hull1',
//       Address: '2454 S. Apple St. , Boise, ID, 83706',
//       Address1: '2454 S. Apple St. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058406240,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Blake Haggett Avest Commercial '],
//       Listing_BrokerDOTmyID: [712675836],
//       Modified_Time: '01-31-18 09:55:24',
//       Modified_User: 'shannon.hull1',
//       Name: 'Zen Bento - Apple St.',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 712557182,
//       Seller_Landlord: ['Southshore LLC '],
//       Seller_LandlordDOTmyID: [712599724],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Lease',
//       StatusDOTmyID: '144662939',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Zen Bento - Apple St.&topParentID=712557182&tm_style=__due&cmd=&iList=Property&formID=243881000058406251&formMyID=712557182&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83706',
//       Zoning: '',
//       cmd: '',
//       myID: 712557182,
//       subFormAction: '',
//       touch: '01-31-18',
//       touchOther: '01-31-18'
//     },
//     {
//       Added_Time: '11-30-17 14:49:55',
//       Added_User: 'shannon.hull1',
//       Address: '135 S. Washington Ave. , Emmett, ID, 83617',
//       Address1: '135 S. Washington Ave.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Emmett',
//       Deal_Type: ['Sale', 'Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058361100,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:04',
//       Modified_User: 'ensobase',
//       Name: '135 S. Washington - Farr',
//       Notes: '\n',
//       Parcel_Number: '',
//       ParentID: 630740132,
//       Seller_Landlord: ['JJF LLC - Gerald Farr  JJF LLC'],
//       Seller_LandlordDOTmyID: [630846137],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=135 S. Washington - Farr&topParentID=630740132&tm_style=__due&cmd=&iList=Property&formID=243881000058361090&formMyID=630740132&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83617',
//       Zoning: '',
//       cmd: '',
//       myID: 630740132,
//       subFormAction: '',
//       touch: '03-05-18',
//       touchOther: '11-30-17'
//     },
//     {
//       Added_Time: '11-30-17 14:42:45',
//       Added_User: 'shannon.hull1',
//       Address: '6355 Main St. , Bonners Ferry, ID, 83805',
//       Address1: '6355 Main St. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Bonners Ferry ',
//       Deal_Type: ['Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058361020,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Shopko-Hometown - Bonners Ferry',
//       Notes: 'This property profile pulls up under 6339 Main St. ',
//       Parcel_Number: '',
//       ParentID: 630542031,
//       Seller_Landlord: ['Bonners Ferry Partners LLC '],
//       Seller_LandlordDOTmyID: [747297256],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Shopko-Hometown - Bonners Ferry&topParentID=630542031&tm_style=__due&cmd=&iList=Property&formID=243881000058361027&formMyID=630542031&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Investment',
//       Zip_Postal_Code: '83805',
//       Zoning: '',
//       cmd: '',
//       myID: 630542031,
//       subFormAction: '',
//       touch: '12-13-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '11-14-17 08:13:48',
//       Added_User: 'shannon.hull1',
//       Address: '3055 East Fairview Ave. , Meridian, ID, 83642',
//       Address1: '3055 East Fairview Ave. ',
//       Address2: '',
//       Asking_Price: ' 4,767,811.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Deal_Type: ['Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000058219140,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Fairview Pavilion',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 224164284,
//       Seller_Landlord: ['Fairview Pavilion Idaho LLC '],
//       Seller_LandlordDOTmyID: [956339185],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Fairview Pavilion&topParentID=224164284&tm_style=__due&cmd=&iList=Property&formID=243881000058219140&formMyID=224164284&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Investment',
//       Zip_Postal_Code: '83642',
//       Zoning: '',
//       cmd: '',
//       myID: 224164284,
//       subFormAction: '',
//       touch: '02-15-18',
//       touchOther: '03-21-18'
//     },
//     {
//       Added_Time: '11-06-17 10:12:19',
//       Added_User: 'shannon.hull1',
//       Address: '1545 W. Broadway , Idaho Falls, ID, 83402',
//       Address1: '1545 W. Broadway',
//       Address2: '',
//       Asking_Price: ' 2,800,000.00',
//       Building_Size_SqFt: '',
//       City: 'Idaho Falls ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057997730,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Brent Wilson Thornton Oliver Keller'],
//       Listing_BrokerDOTmyID: [289669846],
//       Modified_Time: '02-06-18 08:19:47',
//       Modified_User: 'shannon.hull1',
//       Name: '1545 W. Broadway - IF - Stroud ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 540592745,
//       Seller_Landlord: ['SPE 1- LLC  '],
//       Seller_LandlordDOTmyID: [540615310],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=1545 W. Broadway - IF - Stroud &topParentID=540592745&tm_style=__due&cmd=&iList=Property&formID=243881000057997734&formMyID=540592745&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83402',
//       Zoning: '',
//       cmd: '',
//       myID: 540592745,
//       subFormAction: '',
//       touch: '02-06-18',
//       touchOther: '02-06-18'
//     },
//     {
//       Added_Time: '11-06-17 10:03:52',
//       Added_User: 'shannon.hull1',
//       Address: '817 N. Meridian Rd. , Kuna, ID, ',
//       Address1: '817 N. Meridian Rd.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Kuna ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057997570,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '817 N. Meridian Rd. -  Emmett Partners',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 540128024,
//       Seller_Landlord: ['Emmett Partners- LLC - Jeremy Terry Emmett Partners'],
//       Seller_LandlordDOTmyID: [379400699],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=817 N. Meridian Rd. -  Emmett Partners&topParentID=540128024&tm_style=__due&cmd=&iList=Property&formID=243881000057997571&formMyID=540128024&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 540128024,
//       subFormAction: '',
//       touch: '11-06-17',
//       touchOther: '12-19-17'
//     },
//     {
//       Added_Time: '11-06-17 09:38:08',
//       Added_User: 'shannon.hull1',
//       Address: '3650 E. Commercial , Meridian, , 83642',
//       Address1: '3650 E. Commercial ',
//       Address2: '',
//       Asking_Price: ' 8,200,000.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057997500,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Jake Miller Cushman & Wakefield Pacific'],
//       Listing_BrokerDOTmyID: [289670479],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '3650 E. Commercial - Capitol Distributing ',
//       Notes: 'Jake Marketing',
//       Parcel_Number: '',
//       ParentID: 538572858,
//       Seller_Landlord: ['Capitol Distributing Inc.  '],
//       Seller_LandlordDOTmyID: [538631877],
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=3650 E. Commercial - Capitol Distributing &topParentID=538572858&tm_style=__due&cmd=&iList=Property&formID=243881000057997518&formMyID=538572858&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83642',
//       Zoning: '',
//       cmd: '',
//       myID: 538572858,
//       subFormAction: '',
//       touch: '12-13-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '11-06-17 09:08:36',
//       Added_User: 'shannon.hull1',
//       Address: '1624 S. Broadway , Boise, ID, 83706',
//       Address1: '1624 S. Broadway ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057997300,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '1624 S. Broadway - Lattanzio',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 536836958,
//       Seller_Landlord: [
//         'Chris Lattanzio - Broadway PITA LLC Broadway PITA LLC'
//       ],
//       Seller_LandlordDOTmyID: [289673648],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=1624 S. Broadway - Lattanzio&topParentID=536836958&tm_style=__due&cmd=&iList=Property&formID=243881000057997308&formMyID=536836958&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83706',
//       Zoning: '',
//       cmd: '',
//       myID: 536836958,
//       subFormAction: '',
//       touch: '03-05-18',
//       touchOther: '03-07-18'
//     },
//     {
//       Added_Time: '11-02-17 07:54:05',
//       Added_User: 'shannon.hull1',
//       Address: '113 W. Burnside Ave. , Chubbuck, ID, 83202',
//       Address1: '113 W. Burnside Ave.',
//       Address2: '',
//       Asking_Price: ' 360,000.00',
//       Building_Size_SqFt: '',
//       City: 'Chubbuck',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057987070,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Pizza Hut - Chubbuck',
//       Notes: '2171 lockbox code',
//       Parcel_Number: 'RCIGP000302 RCIGP000304',
//       ParentID: 183066642,
//       Seller_Landlord: ['Gerald Waller  W &H- LLC & PHI LLC'],
//       Seller_LandlordDOTmyID: [909850128],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut - Chubbuck&topParentID=183066642&tm_style=__due&cmd=&iList=Property&formID=243881000057987085&formMyID=183066642&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83202',
//       Zoning: '',
//       cmd: '',
//       myID: 183066642,
//       subFormAction: '',
//       touch: '03-13-18',
//       touchOther: '03-28-18'
//     },
//     {
//       Added_Time: '10-30-17 14:54:30',
//       Added_User: 'shannon.hull1',
//       Address: '1810 -1806 W. State St. , Bolse, ID, 83702',
//       Address1: '1810 -1806 W. State St. ',
//       Address2: '',
//       Asking_Price: ' 835,000.00',
//       Building_Size_SqFt: '',
//       City: 'Bolse',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057973900,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '18th & State ',
//       Notes: 'Confluent is purchaser for Starbucks Build.  ',
//       Parcel_Number: '',
//       ParentID: 949032004,
//       Seller_Landlord: ['Robert J. Gordon  '],
//       Seller_LandlordDOTmyID: [949161938],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=18th & State &topParentID=949032004&tm_style=__due&cmd=&iList=Property&formID=243881000057973889&formMyID=949032004&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83702',
//       Zoning: '',
//       cmd: '',
//       myID: 949032004,
//       subFormAction: '',
//       touch: '02-22-18',
//       touchOther: '02-22-18'
//     },
//     {
//       Added_Time: '10-30-17 14:30:28',
//       Added_User: 'shannon.hull1',
//       Address: '201 W. Boise Ave. , Boise, ID, 83702',
//       Address1: '201 W. Boise Ave. ',
//       Address2: '',
//       Asking_Price: ' 1,480,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057973700,
//       Land_Size_Acres: 1.213,
//       Listing_Broker: ['Gregg Davis  KW Commercial '],
//       Listing_BrokerDOTmyID: [947671560],
//       Modified_Time: '01-08-18 11:01:54',
//       Modified_User: 'shannon.hull1',
//       Name: 'Jacksons - Boise and Pennsylvania - Jacksons',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 947515561,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Jacksons - Boise and Pennsylvania - Jacksons&topParentID=947515561&tm_style=__due&cmd=&iList=Property&formID=243881000057973680&formMyID=947515561&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83702',
//       Zoning: '',
//       cmd: '',
//       myID: 947515561,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: '12-19-17'
//     },
//     {
//       Added_Time: '10-11-17 10:33:07',
//       Added_User: 'shannon.hull1',
//       Address: '2986 N. Eagle Rd. , Meridian, ID, 83646',
//       Address1: '2986 N. Eagle Rd.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057686700,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Rosauers ',
//       Notes:
//         'Sublease 2.93 NNN\nplease text Dave Martin 208 571 0865. He can unlock and lock arm and disarm the security',
//       Parcel_Number: '',
//       ParentID: 291594777,
//       Seller_Landlord: ['Rosauers - Jeffry Philipps Rosauers'],
//       Seller_LandlordDOTmyID: [291740345],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Rosauers &topParentID=291594777&tm_style=__due&cmd=&iList=Property&formID=243881000057686700&formMyID=291594777&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83646',
//       Zoning: '',
//       cmd: '',
//       myID: 291594777,
//       subFormAction: '',
//       touch: '04-16-18',
//       touchOther: '03-16-18'
//     },
//     {
//       Added_Time: '10-11-17 09:32:10',
//       Added_User: 'shannon.hull1',
//       Address: '5033 W. State St. , Boise, ID, 83703',
//       Address1: '5033 W. State St. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 2200,
//       City: 'Boise ',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057686140,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Brianna Miller - TOK '],
//       Listing_BrokerDOTmyID: [287648231],
//       Modified_Time: '12-18-17 00:00:06',
//       Modified_User: 'ensobase',
//       Name: 'Lake Harbor ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 287217476,
//       Seller_Landlord: ['Lake Harbor  '],
//       Seller_LandlordDOTmyID: [287282723],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Lease',
//       StatusDOTmyID: '144662939',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Lake Harbor &topParentID=287217476&tm_style=__due&cmd=&iList=Property&formID=243881000057686154&formMyID=287217476&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83703',
//       Zoning: '',
//       cmd: '',
//       myID: 287217476,
//       subFormAction: '',
//       touch: '10-11-17',
//       touchOther: '11-06-17'
//     },
//     {
//       Added_Time: '10-05-17 11:18:44',
//       Added_User: 'shannon.hull1',
//       Address: '1835 Warm Springs Ave. , Boise, ID, 83712',
//       Address1: '1835 Warm Springs Ave. ',
//       Address2: '',
//       Asking_Price: ' 2,500,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057668300,
//       Land_Size_Acres: '',
//       Listing_Broker: ['NA - NONE '],
//       Listing_BrokerDOTmyID: [776248341],
//       Modified_Time: '12-18-17 00:00:06',
//       Modified_User: 'ensobase',
//       Name: 'ABS - M&W-Warm Springs',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 773985483,
//       Seller_Landlord: ['Warm Springs Properties- LLC - Tate '],
//       Seller_LandlordDOTmyID: [774037538],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=ABS - M&W-Warm Springs&topParentID=773985483&tm_style=__due&cmd=&iList=Property&formID=243881000057668304&formMyID=773985483&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83712',
//       Zoning: '',
//       cmd: '',
//       myID: 773985483,
//       subFormAction: '',
//       touch: '12-08-17',
//       touchOther: '12-08-17'
//     },
//     {
//       Added_Time: '09-21-17 09:31:46',
//       Added_User: 'shannon.hull1',
//       Address: '5941 Fairview Ave. , Boise, , 83704',
//       Address1: '5941 Fairview Ave. ',
//       Address2: '',
//       Asking_Price: ' 475,000.00',
//       Building_Size_SqFt: 3482,
//       City: 'Boise ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057265060,
//       Land_Size_Acres: 0.94,
//       Modified_Time: '01-02-18 16:35:18',
//       Modified_User: 'shannon.hull1',
//       Name: "Arby's - Fairview ",
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 560015529,
//       Seller_Landlord: ['Bailey Company- LLLP Bailey Company- LLLP'],
//       Seller_LandlordDOTmyID: [560075697],
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Arby%27s - Fairview &topParentID=560015529&tm_style=__due&cmd=&iList=Property&formID=243881000057265063&formMyID=560015529&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83704',
//       Zoning: '',
//       cmd: '',
//       myID: 560015529,
//       subFormAction: '',
//       touch: '01-02-18',
//       touchOther: '01-02-18'
//     },
//     {
//       Added_Time: '09-13-17 11:06:15',
//       Added_User: 'shannon.hull1',
//       Address: '1970 West Broadway St. , Idaho Falls, ID, 83402',
//       Address1: '1970 West Broadway St.',
//       Address2: '',
//       Asking_Price: ' 405,000.00',
//       Building_Size_SqFt: 2788,
//       City: 'Idaho Falls',
//       Deal_Type: ['Sale', 'Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057033020,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Pizza Hut - Idaho Falls ',
//       Notes: 'Door code 2159',
//       Parcel_Number: 'RPA2580003001N',
//       ParentID: 874570630,
//       Seller_Landlord: ['Gerald Waller  W &H- LLC & PHI LLC'],
//       Seller_LandlordDOTmyID: [909850128],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut - Idaho Falls &topParentID=874570630&tm_style=__due&cmd=&iList=Property&formID=243881000057033011&formMyID=874570630&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83402',
//       Zoning: '',
//       cmd: '',
//       myID: 874570630,
//       subFormAction: '',
//       touch: '02-28-18',
//       touchOther: '01-08-18'
//     },
//     {
//       Added_Time: '09-13-17 09:14:39',
//       Added_User: 'shannon.hull1',
//       Address: '615 N. Sullivan , Spokane Valley, WA, ',
//       Address1: '615 N. Sullivan ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 1200,
//       City: 'Spokane Valley ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057032060,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Upward Ventures LLC (WA) - Sullivan',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 867751665,
//       Seller_Landlord: ['Clark Griffith Family 1- LLC  '],
//       Seller_LandlordDOTmyID: [868634882],
//       Space_SF: '',
//       State_Province: 'WA',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Upward Ventures LLC (WA) - Sullivan&topParentID=867751665&tm_style=__due&cmd=&iList=Property&formID=243881000057032067&formMyID=867751665&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 867751665,
//       subFormAction: '',
//       touch: '12-14-17',
//       touchOther: '03-07-18'
//     },
//     {
//       Added_Time: '09-13-17 09:00:10',
//       Added_User: 'shannon.hull1',
//       Address: 'S. Regal St. , Spokane, WA, 99223',
//       Address1: 'S. Regal St.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 1200,
//       City: 'Spokane ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000057032030,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Upward Ventures LLC (WA) - Regal',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 867013289,
//       Seller_Landlord: ['57th Gem Clean Inc. '],
//       Seller_LandlordDOTmyID: [867136529],
//       Space_SF: '',
//       State_Province: 'WA',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Upward Ventures LLC (WA) - Regal&topParentID=867013289&tm_style=__due&cmd=&iList=Property&formID=243881000057032020&formMyID=867013289&formType=Property&iContactID=',
//       TopParentStatus: 'ooo|ooo',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '99223',
//       Zoning: '',
//       cmd: '',
//       myID: 867013289,
//       subFormAction: '',
//       touch: '12-14-17',
//       touchOther: '01-12-18'
//     },
//     {
//       Added_Time: '08-29-17 09:48:32',
//       Added_User: 'shannon.hull1',
//       Address: '7901 W. Fairview Ave. , Boise, ID, 83704',
//       Address1: '7901 W. Fairview Ave. ',
//       Address2: '',
//       Asking_Price: ' 1,371,428.00',
//       Building_Size_SqFt: 600,
//       City: 'Boise',
//       Deal_Type: ['Investment'],
//       Escalation: 2,
//       Escalation_Note: 'Annual',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056297020,
//       Land_Size_Acres: 0.41,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '03-01-18 11:20:37',
//       Modified_User: 'sara.shropshire1',
//       Name: 'Black Rock - Fairview ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 574022327,
//       Seller_Landlord: ['Chris Lattanzio - Latco SC Latco SC'],
//       Seller_LandlordDOTmyID: [762430052],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Black Rock - Fairview &topParentID=574022327&tm_style=__due&cmd=&iList=Property&formID=243881000056297008&formMyID=574022327&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83704',
//       Zoning: '',
//       cmd: '',
//       myID: 574022327,
//       subFormAction: '',
//       touch: '03-01-18',
//       touchOther: '03-01-18'
//     },
//     {
//       Added_Time: '08-25-17 12:25:37',
//       Added_User: 'shannon.hull1',
//       Address: '220 Ricks Ave. , Rexburg, ID, 83440',
//       Address1: '220 Ricks Ave. ',
//       Address2: '',
//       Asking_Price: ' 2,857,142.00',
//       Building_Size_SqFt: '',
//       City: 'Rexburg',
//       Deal_Type: ['Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056243500,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '02-14-18 10:44:58',
//       Modified_User: 'sara.shropshire1',
//       Name: "Freddy's - Rexburg",
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 237852018,
//       Seller_Landlord: ['Travis Stroud Northwest Ventures LLC'],
//       Seller_LandlordDOTmyID: [289673112],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Off Market',
//       StatusDOTmyID: '80623419',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Freddy%27s - Rexburg&topParentID=237852018&tm_style=__due&cmd=&iList=Property&formID=243881000056243482&formMyID=237852018&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83440',
//       Zoning: '',
//       cmd: '',
//       myID: 237852018,
//       subFormAction: '',
//       touch: '02-06-18',
//       touchOther: '02-14-18'
//     },
//     {
//       Added_Time: '08-25-17 09:47:16',
//       Added_User: 'shannon.hull1',
//       Address: '211 21st Avenue , Caldwell, ID, 83605',
//       Address1: '211 21st Avenue ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056243000,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Golden Dragon - Caldwell',
//       Notes: 'Lease or BTS',
//       Parcel_Number: '',
//       ParentID: 227910454,
//       Seller_Landlord: ['Northwest Development Companies LLC '],
//       Seller_LandlordDOTmyID: [410325239],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Golden Dragon - Caldwell&topParentID=227910454&tm_style=__due&cmd=&iList=Property&formID=243881000056243007&formMyID=227910454&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83605',
//       Zoning: '',
//       cmd: '',
//       myID: 227910454,
//       subFormAction: '',
//       touch: '02-15-18',
//       touchOther: '02-15-18'
//     },
//     {
//       Added_Time: '08-23-17 14:00:23',
//       Added_User: 'shannon.hull1',
//       Address: '7168 1st St. , Bonners Ferry, ID, 83805',
//       Address1: '7168 1st St. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Bonners Ferry ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056230270,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Safeway - Bonners Ferry',
//       Notes:
//         'Access Codes:\nLock Box code is 5182\nAlarm Code for Real Estate is 8214',
//       Parcel_Number: '',
//       ParentID: 70778952,
//       Seller_Landlord: ["Albertson's "],
//       Seller_LandlordDOTmyID: [636408149],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Safeway - Bonners Ferry&topParentID=70778952&tm_style=__due&cmd=&iList=Property&formID=243881000056230261&formMyID=70778952&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83805',
//       Zoning: '',
//       cmd: '',
//       myID: 70778952,
//       subFormAction: '',
//       touch: '08-23-17',
//       touchOther: '08-23-17'
//     },
//     {
//       Added_Time: '08-23-17 13:42:14',
//       Added_User: 'shannon.hull1',
//       Address: 'McCall , McCall, ID, ',
//       Address1: 'McCall ',
//       Address2: '',
//       Asking_Price: ' 23,600,000.00',
//       Building_Size_SqFt: '',
//       City: 'McCall',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056230200,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Brundage ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 68132904,
//       Seller_Landlord: ['Aspirin LLC  Aspirin LLC '],
//       Seller_LandlordDOTmyID: [69662065],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Brundage &topParentID=68132904&tm_style=__due&cmd=&iList=Property&formID=243881000056230194&formMyID=68132904&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 68132904,
//       subFormAction: '',
//       touch: '08-23-17',
//       touchOther: '12-28-17'
//     },
//     {
//       Added_Time: '08-23-17 13:06:24',
//       Added_User: 'shannon.hull1',
//       Address: '700 East Avalon , Kuna, ID, 83634',
//       Address1: '700 East Avalon ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Kuna ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056230180,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'ABS - Kuna ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 67514582,
//       Seller_Landlord: ["Albertson's "],
//       Seller_LandlordDOTmyID: [636408149],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=ABS - Kuna &topParentID=67514582&tm_style=__due&cmd=&iList=Property&formID=243881000056230161&formMyID=67514582&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83634',
//       Zoning: '',
//       cmd: '',
//       myID: 67514582,
//       subFormAction: '',
//       touch: '12-13-17',
//       touchOther: '08-23-17'
//     },
//     {
//       Added_Time: '08-23-17 12:52:17',
//       Added_User: 'shannon.hull1',
//       Address: '125 Valley River Dr. , Rexburg, ID, 83440',
//       Address1: '125 Valley River Dr. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Rexburg ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056230100,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'ABS - Rexburg Retail ',
//       Notes: 'NNN 0.50 2017',
//       Parcel_Number: '',
//       ParentID: 66591860,
//       Seller_Landlord: ["Albertson's "],
//       Seller_LandlordDOTmyID: [636408149],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=ABS - Rexburg Retail &topParentID=66591860&tm_style=__due&cmd=&iList=Property&formID=243881000056230101&formMyID=66591860&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83440',
//       Zoning: '',
//       cmd: '',
//       myID: 66591860,
//       subFormAction: '',
//       touch: '03-26-18',
//       touchOther: '12-12-17'
//     },
//     {
//       Added_Time: '08-23-17 11:52:28',
//       Added_User: 'shannon.hull1',
//       Address: '407 12th Ave. Rd. , Nampa, ID, 83686',
//       Address1: '407 12th Ave. Rd. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Nampa ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056230080,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Pauls - Nampa',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 63082249,
//       Seller_Landlord: ["Albertson's "],
//       Seller_LandlordDOTmyID: [636408149],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pauls - Nampa&topParentID=63082249&tm_style=__due&cmd=&iList=Property&formID=243881000056230083&formMyID=63082249&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83686',
//       Zoning: '',
//       cmd: '',
//       myID: 63082249,
//       subFormAction: '',
//       touch: '10-31-17',
//       touchOther: '10-31-17'
//     },
//     {
//       Added_Time: '08-23-17 11:48:29',
//       Added_User: 'shannon.hull1',
//       Address: '2330 Nez Perce Dr. , Lewiston, ID, 83501',
//       Address1: '2330 Nez Perce Dr. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Lewiston ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056230050,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Safeway - Lewiston',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 62749411,
//       Seller_Landlord: ["Albertson's "],
//       Seller_LandlordDOTmyID: [636408149],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Safeway - Lewiston&topParentID=62749411&tm_style=__due&cmd=&iList=Property&formID=243881000056230056&formMyID=62749411&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83501',
//       Zoning: '',
//       cmd: '',
//       myID: 62749411,
//       subFormAction: '',
//       touch: '01-12-18',
//       touchOther: '01-12-18'
//     },
//     {
//       Added_Time: '08-23-17 11:35:32',
//       Added_User: 'shannon.hull1',
//       Address: '425 N. 10th Avenue , Caldwell, ID, 83605',
//       Address1: '425 N. 10th Avenue ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056230000,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:06',
//       Modified_User: 'ensobase',
//       Name: 'Pauls - Caldwell',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 62021550,
//       Seller_Landlord: ["Albertson's "],
//       Seller_LandlordDOTmyID: [636408149],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pauls - Caldwell&topParentID=62021550&tm_style=__due&cmd=&iList=Property&formID=243881000056230031&formMyID=62021550&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83605',
//       Zoning: '',
//       cmd: '',
//       myID: 62021550,
//       subFormAction: '',
//       touch: '12-13-17',
//       touchOther: '08-23-17'
//     },
//     {
//       Added_Time: '08-23-17 11:19:21',
//       Added_User: 'shannon.hull1',
//       Address: '215 East Jackson St. , Mountain Home, ID, 83647',
//       Address1: '215 East Jackson St.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Mountain Home',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056230000,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Pauls - Mountain Home ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 58981585,
//       Seller_Landlord: ["Albertson's "],
//       Seller_LandlordDOTmyID: [636408149],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pauls - Mountain Home &topParentID=58981585&tm_style=__due&cmd=&iList=Property&formID=243881000056230011&formMyID=58981585&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83647',
//       Zoning: '',
//       cmd: '',
//       myID: 58981585,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: '08-23-17'
//     },
//     {
//       Added_Time: '08-18-17 13:19:06',
//       Added_User: 'shannon.hull1',
//       Address: '3019 N. Cole Rd. Parcel A, B, C, Boise, ID, 83704',
//       Address1: '3019 N. Cole Rd.',
//       Address2: 'Parcel A, B, C ',
//       Asking_Price: ' 3,200,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056214000,
//       Land_Size_Acres: 5.287,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-27-17 12:58:17',
//       Modified_User: 'shannon.hull1',
//       Name: 'Library Plaza (Evergreen Plaza LLC) - Cole Rd.',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 636189642,
//       Seller_Landlord: ['Library Plaza LLC - David Thompson '],
//       Seller_LandlordDOTmyID: [636236716],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Library Plaza (Evergreen Plaza LLC) - Cole Rd.&topParentID=636189642&tm_style=__due&cmd=&iList=Property&formID=243881000056214007&formMyID=636189642&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83704',
//       Zoning: '',
//       cmd: '',
//       myID: 636189642,
//       subFormAction: '',
//       touch: '12-27-17',
//       touchOther: '12-27-17'
//     },
//     {
//       Added_Time: '08-18-17 09:19:50',
//       Added_User: 'shannon.hull1',
//       Address: '160102 N. Highway 41 , Rathdrum, ID, 83858',
//       Address1: '160102 N. Highway 41',
//       Address2: '',
//       Asking_Price: ' 2,100,000.00',
//       Building_Size_SqFt: 36236,
//       City: 'Rathdrum ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056211000,
//       Land_Size_Acres: 2.959,
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'BiMart - Rathdrum',
//       Notes: '6-8 months out - 030218 SH',
//       Parcel_Number: '',
//       ParentID: 621680087,
//       Seller_Landlord: ['Watson Rathdrum Property- LLC  '],
//       Seller_LandlordDOTmyID: [621893293],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=BiMart - Rathdrum&topParentID=621680087&tm_style=__due&cmd=&iList=Property&formID=243881000056211007&formMyID=621680087&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Land',
//       Zip_Postal_Code: '83858',
//       Zoning: '',
//       cmd: '',
//       myID: 621680087,
//       subFormAction: '',
//       touch: '03-02-18',
//       touchOther: '02-06-18'
//     },
//     {
//       Added_Time: '08-17-17 11:29:11',
//       Added_User: 'shannon.hull1',
//       Address: 'Skyway and KCID , Caldwell, ID, 83605',
//       Address1: 'Skyway and KCID',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056206050,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Jacksons - Land-Caldwell',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 542939865,
//       Seller_Landlord: ['The Urban Renewal Agency of City of Caldwell '],
//       Seller_LandlordDOTmyID: [543256275],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Jacksons - Land-Caldwell&topParentID=542939865&tm_style=__due&cmd=&iList=Property&formID=243881000056206054&formMyID=542939865&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Land',
//       Zip_Postal_Code: '83605',
//       Zoning: '',
//       cmd: '',
//       myID: 542939865,
//       subFormAction: '',
//       touch: '10-11-17',
//       touchOther: '04-16-18'
//     },
//     {
//       Added_Time: '08-17-17 11:15:09',
//       Added_User: 'shannon.hull1',
//       Address: 'Locust Street North , Twin Falls, ID, 83301',
//       Address1: 'Locust Street North ',
//       Address2: '',
//       Asking_Price: ' 428,212.00',
//       Building_Size_SqFt: '',
//       City: 'Twin Falls ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000056206000,
//       Land_Size_Acres: 0.786,
//       Modified_Time: '01-12-18 14:40:23',
//       Modified_User: 'shannon.hull1',
//       Name: 'Locust Street - Twin - Huntleigh ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 542262838,
//       Seller_Landlord: [
//         'Locust Grove Development LLC  Locust Grove Development LLC '
//       ],
//       Seller_LandlordDOTmyID: [542315513],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Locust Street - Twin - Huntleigh &topParentID=542262838&tm_style=__due&cmd=&iList=Property&formID=243881000056206007&formMyID=542262838&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Land',
//       Zip_Postal_Code: '83301',
//       Zoning: '',
//       cmd: '',
//       myID: 542262838,
//       subFormAction: '',
//       touch: '01-12-18',
//       touchOther: '01-12-18'
//     },
//     {
//       Added_Time: '08-09-17 16:42:19',
//       Added_User: 'shannon.hull1',
//       Address: '4013 Yellowstone Ave. , Chubbuck, ID, 83202',
//       Address1: '4013 Yellowstone Ave.',
//       Address2: '',
//       Asking_Price: ' 5,641,652.00',
//       Building_Size_SqFt: 11038,
//       City: 'Chubbuck',
//       Deal_Type: ['Lease', 'Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055944060,
//       Land_Size_Acres: 1.57,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '4013 - Multitenant - Chubbuck',
//       Notes: 'Lockbox backl of property with key = 7042',
//       Parcel_Number: '',
//       ParentID: 870230236,
//       Seller_Landlord: ['Chris Lattanzio - Latco SC Latco SC'],
//       Seller_LandlordDOTmyID: [762430052],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=4013 - Multitenant - Chubbuck&topParentID=870230236&tm_style=__due&cmd=&iList=Property&formID=243881000055944068&formMyID=870230236&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83202',
//       Zoning: '',
//       cmd: '',
//       myID: 870230236,
//       subFormAction: '',
//       touch: '03-20-18',
//       touchOther: '04-05-18'
//     },
//     {
//       Added_Time: '08-08-17 16:18:58',
//       Added_User: 'shannon.hull1',
//       Address: '3945 Pole Line Rd. , Pocatello, ID, 83201',
//       Address1: '3945 Pole Line Rd. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Pocatello',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055934000,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '03-07-18 08:33:06',
//       Modified_User: 'shannon.hull1',
//       Name: '3945 Pole Line Rd. - Pocatello',
//       Notes: 'Need listing back',
//       Parcel_Number: '',
//       ParentID: 782900914,
//       Seller_Landlord: ['Brett Burgher  '],
//       Seller_LandlordDOTmyID: [783066166],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=3945 Pole Line Rd. - Pocatello&topParentID=782900914&tm_style=__due&cmd=&iList=Property&formID=243881000055934020&formMyID=782900914&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83201',
//       Zoning: '',
//       cmd: '',
//       myID: 782900914,
//       subFormAction: '',
//       touch: '03-07-18',
//       touchOther: '03-07-18'
//     },
//     {
//       Added_Time: '08-08-17 10:35:31',
//       Added_User: 'shannon.hull1',
//       Address: '687 Blue Lakes Blvd., North , Twin Falls, ID, 83301',
//       Address1: '687 Blue Lakes Blvd., North ',
//       Address2: '',
//       Asking_Price: ' 1,760,000.00',
//       Building_Size_SqFt: 2200,
//       City: 'Twin Falls ',
//       Deal_Type: ['Investment'],
//       Escalation: 10,
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055892100,
//       Land_Size_Acres: 0.667,
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Chipotle - Twin ',
//       Notes: 'Not absolute - LL responsible for roof and structure ',
//       Parcel_Number: '',
//       ParentID: 762351209,
//       Seller_Landlord: ['Chris Lattanzio - Latco SC Latco SC'],
//       Seller_LandlordDOTmyID: [762430052],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Chipotle - Twin &topParentID=762351209&tm_style=__due&cmd=&iList=Property&formID=243881000055892084&formMyID=762351209&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83301',
//       Zoning: '',
//       cmd: '',
//       myID: 762351209,
//       subFormAction: '',
//       touch: '03-30-18',
//       touchOther: '10-30-17'
//     },
//     {
//       Added_Time: '08-08-17 10:12:18',
//       Added_User: 'shannon.hull1',
//       Address: '683 Blue Lakes Blvd. North , Twin Falls, ID, 83301',
//       Address1: '683 Blue Lakes Blvd. North',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 2940,
//       City: 'Twin Falls ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055892000,
//       Land_Size_Acres: 0.98,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '683 Blue Lakes - Mutli-Tenant - Lattanzio',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 760395401,
//       Seller_Landlord: [
//         'Chris Lattanzio - Blue Lakes 687 LP Blue Lakes 687 LP'
//       ],
//       Seller_LandlordDOTmyID: [761070350],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=683 Blue Lakes - Mutli-Tenant - Lattanzio&topParentID=760395401&tm_style=__due&cmd=&iList=Property&formID=243881000055892012&formMyID=760395401&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Multi-Tenant',
//       Zip_Postal_Code: '83301',
//       Zoning: 'C-1',
//       cmd: '',
//       myID: 760395401,
//       subFormAction: '',
//       touch: '12-04-17',
//       touchOther: '01-29-18'
//     },
//     {
//       Added_Time: '08-07-17 13:15:28',
//       Added_User: 'sara.shropshire1',
//       Address: '2598 E Sunnyside Rd , Ammon, ID, 83406',
//       Address1: '2598 E Sunnyside Rd',
//       Address2: '',
//       Asking_Price: ' 2,438,095.00',
//       Building_Size_SqFt: 2690,
//       City: 'Ammon',
//       Escalation: 10,
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055884000,
//       Land_Size_Acres: 1.198,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Popeyes - Absolute NNN Investment For Sale - Ammon',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 683886974,
//       Seller_Landlord: ['Christian Taylor Ball Ventures'],
//       Seller_LandlordDOTmyID: [685280965],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Popeyes - Absolute NNN Investment For Sale - Ammon&topParentID=683886974&tm_style=__due&cmd=&iList=Property&formID=243881000055884007&formMyID=683886974&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83406',
//       Zoning: '',
//       cmd: '',
//       myID: 683886974,
//       subFormAction: '',
//       touch: '11-06-17',
//       touchOther: '11-06-17'
//     },
//     {
//       Added_Time: '08-04-17 11:59:08',
//       Added_User: 'shannon.hull1',
//       Address: '1505 NE 3rd St. , Prineville, OR, 97754',
//       Address1: '1505 NE 3rd St. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Prineville',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055877150,
//       Land_Size_Acres: '',
//       Listing_Broker: [
//         'Joel Thomas and Russell Huntamer  Compass Commercial Real Estate '
//       ],
//       Listing_BrokerDOTmyID: [421847725],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Pizza Hut - Prineville, OR',
//       Notes: 'Terminated 090117',
//       Parcel_Number: '',
//       ParentID: 421721993,
//       Seller_Landlord: ['Carolyn Rich W &H LLC- PHI LLC'],
//       Seller_LandlordDOTmyID: [758337068],
//       Space_SF: '',
//       State_Province: 'OR',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut - Prineville, OR&topParentID=421721993&tm_style=__due&cmd=&iList=Property&formID=243881000055877159&formMyID=421721993&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '97754',
//       Zoning: '',
//       cmd: '',
//       myID: 421721993,
//       subFormAction: '',
//       touch: '10-02-17',
//       touchOther: ''
//     },
//     {
//       Added_Time: '07-24-17 11:31:58',
//       Added_User: 'shannon.hull1',
//       Address: '423 S. Lincoln , Jerome, ID, 83338',
//       Address1: '423 S. Lincoln ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 1400,
//       City: 'Jerome ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055673180,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Pizza Hut -  423 S. Lincoln - Jerome ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 469657312,
//       Seller_Landlord: ['CJM LP '],
//       Seller_LandlordDOTmyID: [469715950],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut -  423 S. Lincoln - Jerome &topParentID=469657312&tm_style=__due&cmd=&iList=Property&formID=243881000055673191&formMyID=469657312&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83338',
//       Zoning: '',
//       cmd: '',
//       myID: 469657312,
//       subFormAction: '',
//       touch: '07-24-17',
//       touchOther: '07-24-17'
//     },
//     {
//       Added_Time: '07-24-17 10:55:51',
//       Added_User: 'shannon.hull1',
//       Address: '1210 S. Lincoln Ave. , Jerome, ID, 83338',
//       Address1: '1210 S. Lincoln Ave. ',
//       Address2: '',
//       Asking_Price: ' 230,000.00',
//       Building_Size_SqFt: 1800,
//       City: 'Jerome',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055673120,
//       Land_Size_Acres: 0.359,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Pizza Hut - 1210 Lincoln - Jerome ',
//       Notes: '6% commission',
//       Parcel_Number: 'RPJ13701610030A',
//       ParentID: 466088129,
//       Seller_Landlord: ['Gerald Waller  W &H- LLC & PHI LLC'],
//       Seller_LandlordDOTmyID: [909850128],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut - 1210 Lincoln - Jerome &topParentID=466088129&tm_style=__due&cmd=&iList=Property&formID=243881000055673110&formMyID=466088129&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83338',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 466088129,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: '01-08-18'
//     },
//     {
//       Added_Time: '07-21-17 09:56:55',
//       Added_User: 'shannon.hull1',
//       Address: '425 N. 10th Avenue , Caldwell, ID, 83605',
//       Address1: '425 N. 10th Avenue ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055627000,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '01-08-18 12:03:26',
//       Modified_User: 'shannon.hull1',
//       Name: 'BiMart - Caldwell',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 204895815,
//       Seller_Landlord: ['ABS ID-O LLC ABS ID-O LLC'],
//       Seller_LandlordDOTmyID: [293005033],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=BiMart - Caldwell&topParentID=204895815&tm_style=__due&cmd=&iList=Property&formID=243881000055627003&formMyID=204895815&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83605',
//       Zoning: '',
//       cmd: '',
//       myID: 204895815,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: '11-14-17'
//     },
//     {
//       Added_Time: '07-13-17 11:09:35',
//       Added_User: 'shannon.hull1',
//       Address: '1549 Blue Lakes Blvd. N. , Twin Falls, ID, 83301',
//       Address1: '1549 Blue Lakes Blvd. N. ',
//       Address2: '',
//       Asking_Price: ' 1,900,000.00',
//       Building_Size_SqFt: 3024,
//       City: 'Twin Falls ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055382100,
//       Land_Size_Acres: 0.69,
//       Modified_Time: '02-20-18 10:27:51',
//       Modified_User: 'sara.shropshire1',
//       Name: 'KFC - Twin Falls ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 517813675,
//       Seller_Landlord: ["Harman's of Idaho LLC  "],
//       Seller_LandlordDOTmyID: [516750390],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=KFC - Twin Falls &topParentID=517813675&tm_style=__due&cmd=&iList=Property&formID=243881000055382102&formMyID=517813675&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83301',
//       Zoning: '',
//       cmd: '',
//       myID: 517813675,
//       subFormAction: '',
//       touch: '02-20-18',
//       touchOther: '09-15-17'
//     },
//     {
//       Added_Time: '07-13-17 10:47:33',
//       Added_User: 'shannon.hull1',
//       Address: '568 N. 2nd East , Rexburg, ID, 83440',
//       Address1: '568 N. 2nd East',
//       Address2: '',
//       Asking_Price: ' 2,500,000.00',
//       Building_Size_SqFt: 1920,
//       City: 'Rexburg',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055382050,
//       Land_Size_Acres: 0.58,
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'KFC - Rexburg ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 513809407,
//       Seller_Landlord: ["Harman's of Idaho LLC  "],
//       Seller_LandlordDOTmyID: [516750390],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=KFC - Rexburg &topParentID=513809407&tm_style=__due&cmd=&iList=Property&formID=243881000055382058&formMyID=513809407&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83440',
//       Zoning: '',
//       cmd: '',
//       myID: 513809407,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: '03-19-18'
//     },
//     {
//       Added_Time: '07-13-17 08:42:09',
//       Added_User: 'shannon.hull1',
//       Address: '1750 W. McMillan Rd. , Meridian, ID, 83646',
//       Address1: '1750 W. McMillan Rd. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 1559,
//       City: 'Meridian',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055382000,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Bob Mitchell CSM Thornton Oliver Keller'],
//       Listing_BrokerDOTmyID: [289669779],
//       Modified_Time: '03-07-18 08:26:31',
//       Modified_User: 'shannon.hull1',
//       Name: 'TSC - Linder and McMillan',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 509126121,
//       Seller_Landlord: ['BlackhawkMeridian LLC  '],
//       Seller_LandlordDOTmyID: [995487453],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=TSC - Linder and McMillan&topParentID=509126121&tm_style=__due&cmd=&iList=Property&formID=243881000055382003&formMyID=509126121&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83646',
//       Zoning: '',
//       cmd: '',
//       myID: 509126121,
//       subFormAction: '',
//       touch: '03-02-18',
//       touchOther: '03-07-18'
//     },
//     {
//       Added_Time: '07-10-17 16:17:22',
//       Added_User: 'shannon.hull1',
//       Address: '3004 Cleveland Blvd. , Caldwell, ID, 83605',
//       Address1: '3004 Cleveland Blvd.',
//       Address2: '',
//       Asking_Price: ' 2,100,000.00',
//       Building_Size_SqFt: 2200,
//       City: 'Caldwell',
//       Deal_Type: ['Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055364000,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '02-01-18 13:32:44',
//       Modified_User: 'shannon.hull1',
//       Name: 'Starbucks - Cleveland Blvd.',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 277244075,
//       Seller_Landlord: ['Latco SC Latco SC'],
//       Seller_LandlordDOTmyID: [277335074],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Starbucks - Cleveland Blvd.&topParentID=277244075&tm_style=__due&cmd=&iList=Property&formID=243881000055364007&formMyID=277244075&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83605',
//       Zoning: '',
//       cmd: '',
//       myID: 277244075,
//       subFormAction: '',
//       touch: '01-30-18',
//       touchOther: '02-01-18'
//     },
//     {
//       Added_Time: '07-05-17 14:10:40',
//       Added_User: 'shannon.hull1',
//       Address: '147 N. 3rd St. , McCall, ID, 83638',
//       Address1: '147 N. 3rd St. ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'McCall',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055345000,
//       Land_Size_Acres: '',
//       Modified_Time: '02-06-18 08:23:30',
//       Modified_User: 'shannon.hull1',
//       Name: "ABS - Jim's Grocery",
//       Notes: '',
//       Parcel_Number: 'RPM00000164681',
//       ParentID: 837723636,
//       Seller_Landlord: ['Barbara Kutterer '],
//       Seller_LandlordDOTmyID: [837741940],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Inactive',
//       StatusDOTmyID: '216920258',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=ABS - Jim%27s Grocery&topParentID=837723636&tm_style=__due&cmd=&iList=Property&formID=243881000055345007&formMyID=837723636&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83638',
//       Zoning: '',
//       cmd: '',
//       myID: 837723636,
//       subFormAction: '',
//       touch: '02-06-18',
//       touchOther: '02-06-18'
//     },
//     {
//       Added_Time: '07-05-17 09:47:06',
//       Added_User: 'shannon.hull1',
//       Address: "1940 Beebe Blvd. , Coeur d'Alene, ID, 83814",
//       Address1: '1940 Beebe Blvd.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 1262,
//       City: "Coeur d'Alene ",
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055342000,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Upward Ventures LLC (ID) - CDA',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 821889825,
//       Seller_Landlord: ['Idaho Retail LLC '],
//       Seller_LandlordDOTmyID: [819842670],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Upward Ventures LLC (ID) - CDA&topParentID=821889825&tm_style=__due&cmd=&iList=Property&formID=243881000055342003&formMyID=821889825&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83814',
//       Zoning: '',
//       cmd: '',
//       myID: 821889825,
//       subFormAction: '',
//       touch: '12-14-17',
//       touchOther: '08-03-17'
//     },
//     {
//       Added_Time: '06-30-17 09:29:16',
//       Added_User: 'shannon.hull1',
//       Address: 'Sunnyside and Hitt Road , Idaho Falls, ID, 83404',
//       Address1: 'Sunnyside and Hitt Road ',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Idaho Falls ',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000055132000,
//       Land_Size_Acres: 1.264,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'WAFED - Sunnyside & Hitt',
//       Notes: 'SWC ',
//       Parcel_Number: '',
//       ParentID: 388265359,
//       Seller_Landlord: ['Washington Federal  Washington Federal'],
//       Seller_LandlordDOTmyID: [388632547],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=WAFED - Sunnyside & Hitt&topParentID=388265359&tm_style=__due&cmd=&iList=Property&formID=243881000055132007&formMyID=388265359&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83404',
//       Zoning: '',
//       cmd: '',
//       myID: 388265359,
//       subFormAction: '',
//       touch: '12-05-17',
//       touchOther: '11-06-17'
//     },
//     {
//       Added_Time: '06-27-17 12:48:14',
//       Added_User: 'shannon.hull1',
//       Address: '16375 N. Merchant Way , Nampa, ID, 83687',
//       Address1: '16375 N. Merchant Way',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: 11538,
//       City: 'Nampa',
//       Deal_Type: ['Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000054429020,
//       Land_Size_Acres: 1.21,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: '16375 N. Merchant Way',
//       Notes: '32.00SF',
//       Parcel_Number: '66',
//       ParentID: 140953359,
//       Seller_Landlord: ['Alan Cantlin Madison Nampa LLC '],
//       Seller_LandlordDOTmyID: [141029174],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=16375 N. Merchant Way&topParentID=140953359&tm_style=__due&cmd=&iList=Property&formID=243881000054429023&formMyID=140953359&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83687',
//       Zoning: '',
//       cmd: '',
//       myID: 140953359,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: '02-06-18'
//     },
//     {
//       Added_Time: '06-22-17 12:27:01',
//       Added_User: 'andrea.nilson1',
//       Address: '4379 W. Chinden Blvd. , Garden City (Boise), ID, 83714',
//       Address1: '4379 W. Chinden Blvd.',
//       Address2: '',
//       Asking_Price: ' 3,091,309.00',
//       Building_Size_SqFt: 14990,
//       City: 'Garden City (Boise) ',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000054326000,
//       Land_Size_Acres: 51400,
//       Listing_Broker: ['Andrea Nilson CWP'],
//       Listing_BrokerDOTmyID: [243881],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Advance Auto Parts HUB Location ',
//       Notes: '5% Commission \nDelivery July 31\n\n',
//       Parcel_Number: '',
//       ParentID: 708130948,
//       Seller_Landlord: ['B & S Investments LLC B & S Investments LLC'],
//       Seller_LandlordDOTmyID: [281144052],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Advance Auto Parts HUB Location &topParentID=708130948&tm_style=__due&cmd=&iList=Property&formID=243881000054326003&formMyID=708130948&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83714',
//       Zoning: 'C-2',
//       cmd: '',
//       myID: 708130948,
//       subFormAction: '',
//       touch: '10-24-17',
//       touchOther: '10-24-17'
//     },
//     {
//       Added_Time: '06-20-17 13:08:08',
//       Added_User: 'shannon.hull1',
//       Address: '10 S. Orchard , Boise, ID, 83705',
//       Address1: '10 S. Orchard ',
//       Address2: '',
//       Asking_Price: ' 525,000.00',
//       Building_Size_SqFt: 3373,
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000054216000,
//       Land_Size_Acres: 0.51,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'WAFED - Orchard ',
//       Notes: '',
//       Parcel_Number: 'R7777800191',
//       ParentID: 537676442,
//       Seller_Landlord: ['Ricka Gerstmann Washington Federal'],
//       Seller_LandlordDOTmyID: [289674319],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=WAFED - Orchard &topParentID=537676442&tm_style=__due&cmd=&iList=Property&formID=243881000054216013&formMyID=537676442&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83705',
//       Zoning: '',
//       cmd: '',
//       myID: 537676442,
//       subFormAction: '',
//       touch: '09-15-17',
//       touchOther: '09-15-17'
//     },
//     {
//       Added_Time: '06-14-17 16:28:18',
//       Added_User: 'shannon.hull1',
//       Address: '1876 N. Yellowstone Hwy. , Idaho Falls, ID, 83401',
//       Address1: '1876 N. Yellowstone Hwy.',
//       Address2: '',
//       Asking_Price: ' 1,030,000.00',
//       Building_Size_SqFt: 5480,
//       City: 'Idaho Falls ',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000054068030,
//       Land_Size_Acres: 0.5131,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Sherwin Williams - Idaho Falls',
//       Notes: '6% Commission',
//       Parcel_Number: 'RPA00008088755, RPA1050001001B',
//       ParentID: 31537499,
//       Seller_Landlord: ['Bradley Enterprises- Inc.  '],
//       Seller_LandlordDOTmyID: [31384693],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Sherwin Williams - Idaho Falls&topParentID=31537499&tm_style=__due&cmd=&iList=Property&formID=243881000054068025&formMyID=31537499&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83401',
//       Zoning: '',
//       cmd: '',
//       myID: 31537499,
//       subFormAction: '',
//       touch: '12-05-17',
//       touchOther: '09-01-17'
//     },
//     {
//       Added_Time: '06-06-17 16:34:49',
//       Added_User: 'shannon.hull1',
//       Address: '2275 S. Ten Mile Rd. , Meridian, ID, 83642',
//       Address1: '2275 S. Ten Mile Rd.',
//       Address2: '',
//       Asking_Price: ' 914,000.00',
//       Building_Size_SqFt: 2692,
//       City: 'Meridian',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000053833540,
//       Land_Size_Acres: 4.9,
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Jacksons - Ten Mile Rd',
//       Notes: '',
//       Parcel_Number: 'R7569810062',
//       ParentID: 339387048,
//       Seller_Landlord: ['Barry and Kathy Brillheart '],
//       Seller_LandlordDOTmyID: [339741539],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Jacksons - Ten Mile Rd&topParentID=339387048&tm_style=__due&cmd=&iList=Property&formID=243881000053833547&formMyID=339387048&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83642',
//       Zoning: 'RUT',
//       cmd: '',
//       myID: 339387048,
//       subFormAction: '',
//       touch: '06-06-17',
//       touchOther: '04-16-18'
//     },
//     {
//       Added_Time: '06-06-17 15:27:41',
//       Added_User: 'shannon.hull1',
//       Address: '6259 N. Linder Rd. , Meridian, ID, 83646',
//       Address1: '6259 N. Linder Rd.',
//       Address2: '',
//       Asking_Price: ' 2,347,826.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian ',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000053833380,
//       Land_Size_Acres: 1.187,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Dollar Tree - Linder',
//       Notes: 'Property address FKA 6241',
//       Parcel_Number: 'R4995330025',
//       ParentID: 336393068,
//       Seller_Landlord: ['B & S Investments LLC B & S Investments LLC'],
//       Seller_LandlordDOTmyID: [281144052],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Dollar Tree - Linder&topParentID=336393068&tm_style=__due&cmd=&iList=Property&formID=243881000053833384&formMyID=336393068&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83646',
//       Zoning: '',
//       cmd: '',
//       myID: 336393068,
//       subFormAction: '',
//       touch: '08-03-17',
//       touchOther: '08-03-17'
//     },
//     {
//       Added_Time: '06-05-17 14:56:25',
//       Added_User: 'shannon.hull1',
//       Address: '821 N. Meridian Rd. , Kuna, ID, 83634',
//       Address1: '821 N. Meridian Rd. ',
//       Address2: '',
//       Asking_Price: ' 400,000.00',
//       Building_Size_SqFt: '',
//       City: 'Kuna ',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000053829000,
//       Land_Size_Acres: 5.79,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: '821 N. Meridian Rd - Lesley',
//       Notes: '',
//       Parcel_Number: 'S1324142215',
//       ParentID: 247769213,
//       Seller_Landlord: ['Emmett Partners- LLC - Jeremy Terry Emmett Partners'],
//       Seller_LandlordDOTmyID: [379400699],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=821 N. Meridian Rd - Lesley&topParentID=247769213&tm_style=__due&cmd=&iList=Property&formID=243881000053829003&formMyID=247769213&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Land',
//       Zip_Postal_Code: '83634',
//       Zoning: '',
//       cmd: '',
//       myID: 247769213,
//       subFormAction: '',
//       touch: '07-05-17',
//       touchOther: '07-05-17'
//     },
//     {
//       Added_Time: '06-01-17 14:29:10',
//       Added_User: 'shannon.hull1',
//       Address: '1011 N. Meridian Rd. , Kuna, ID, 83634',
//       Address1: '1011 N. Meridian Rd.',
//       Address2: '',
//       Asking_Price: ' 400,000.00',
//       Building_Size_SqFt: '',
//       City: 'Kuna ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000053805950,
//       Land_Size_Acres: 1.42,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '04-09-18 09:45:47',
//       Modified_User: 'shannon.hull1',
//       Name: 'Smoky Mountain - Kuna ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 900029628,
//       Seller_Landlord: ['Emmett Partners- LLC - Jeremy Terry Emmett Partners'],
//       Seller_LandlordDOTmyID: [379400699],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Smoky Mountain - Kuna &topParentID=900029628&tm_style=__due&cmd=&iList=Property&formID=243881000053805951&formMyID=900029628&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Land',
//       Zip_Postal_Code: '83634',
//       Zoning: '',
//       cmd: '',
//       myID: 900029628,
//       subFormAction: '',
//       touch: '04-09-18',
//       touchOther: '04-09-18'
//     },
//     {
//       Added_Time: '06-01-17 12:49:01',
//       Added_User: 'shannon.hull1',
//       Address: '818 Ann Morrison , Boise, ID, 83706',
//       Address1: '818 Ann Morrison ',
//       Address2: '',
//       Asking_Price: ' 1,250,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000053805860,
//       Land_Size_Acres: '',
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: '818 Ann Morrison ',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 895049793,
//       Seller_Landlord: ['P.H.I. LLC  '],
//       Seller_LandlordDOTmyID: [895698332],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=818 Ann Morrison &topParentID=895049793&tm_style=__due&cmd=&iList=Property&formID=243881000053805861&formMyID=895049793&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Land',
//       Zip_Postal_Code: '83706',
//       Zoning: '',
//       cmd: '',
//       myID: 895049793,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: '04-09-18'
//     },
//     {
//       Added_Time: '06-01-17 11:33:29',
//       Added_User: 'shannon.hull1',
//       Address: '119 E. Logan St. , Caldwell, ID, 83605',
//       Address1: '119 E. Logan St.',
//       Address2: '',
//       Asking_Price: ' 228,000.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000053805820,
//       Land_Size_Acres: 0.22,
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: '119 E. Logan St. ',
//       Notes: '',
//       Parcel_Number: '01448000 0 ',
//       ParentID: 889820038,
//       Seller_Landlord: ['Kenneth A. Fish & Esther P. Fish  '],
//       Seller_LandlordDOTmyID: [889897193],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=119 E. Logan St. &topParentID=889820038&tm_style=__due&cmd=&iList=Property&formID=243881000053805818&formMyID=889820038&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83605',
//       Zoning: '',
//       cmd: '',
//       myID: 889820038,
//       subFormAction: '',
//       touch: '12-15-17',
//       touchOther: '08-03-17'
//     },
//     {
//       Added_Time: '05-24-17 16:45:27',
//       Added_User: 'shannon.hull1',
//       Address: '412 E. Fairview Ave. , Meridian, ID, 83642',
//       Address1: '412 E. Fairview Ave. ',
//       Address2: '',
//       Asking_Price: ' 335,000.00',
//       Building_Size_SqFt: 2020,
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000053764030,
//       Land_Size_Acres: 0.5,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Jacksons - 412 E. Fairview Ave. ',
//       Notes: '',
//       Parcel_Number: 'S1106346910',
//       ParentID: 218073433,
//       Seller_Landlord: [
//         'Jacksons Food Stores- Inc.  Jacksons Food Stores- Inc.'
//       ],
//       Seller_LandlordDOTmyID: [275458660],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Jacksons - 412 E. Fairview Ave. &topParentID=218073433&tm_style=__due&cmd=&iList=Property&formID=243881000053764026&formMyID=218073433&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83642',
//       Zoning: 'C-G',
//       cmd: '',
//       myID: 218073433,
//       subFormAction: '',
//       touch: '06-27-17',
//       touchOther: '06-27-17'
//     },
//     {
//       Added_Time: '05-04-17 12:06:00',
//       Added_User: 'shannon.hull1',
//       Address: '625 Yellowstone Ave. , Pocatello, ID, 83201',
//       Address1: '625 Yellowstone Ave.',
//       Address2: '',
//       Asking_Price: ' 1,846,320.00',
//       Building_Size_SqFt: 10990,
//       City: 'Pocatello',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000053559100,
//       Land_Size_Acres: 0.77,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Advance Auto - Pocatello ',
//       Notes: '',
//       Parcel_Number: 'RPCPP073811',
//       ParentID: 472916475,
//       Seller_Landlord: ['Northwest Development Companies LLC '],
//       Seller_LandlordDOTmyID: [410325239],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Advance Auto - Pocatello &topParentID=472916475&tm_style=__due&cmd=&iList=Property&formID=243881000053559116&formMyID=472916475&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Investment',
//       Zip_Postal_Code: '83201',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 472916475,
//       subFormAction: '',
//       touch: '02-06-18',
//       touchOther: '04-16-18'
//     },
//     {
//       Added_Time: '05-04-17 10:39:17',
//       Added_User: 'shannon.hull1',
//       Address: '110 N. Holmes Ave. , Idaho Falls, ID, 83401',
//       Address1: '110 N. Holmes Ave.',
//       Address2: '',
//       Asking_Price: ' 290,000.00',
//       Building_Size_SqFt: 2037,
//       City: 'Idaho Falls ',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000053559000,
//       Land_Size_Acres: 0.2834,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'WAFED - Holmes',
//       Notes: 'code 8212',
//       Parcel_Number: 'RPA0420031025AA',
//       ParentID: 468063863,
//       Seller_Landlord: ['Ricka Gerstmann Washington Federal'],
//       Seller_LandlordDOTmyID: [289674319],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=WAFED - Holmes&topParentID=468063863&tm_style=__due&cmd=&iList=Property&formID=243881000053559010&formMyID=468063863&formType=Property&iContactID=',
//       TopParentStatus: '',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83401',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 468063863,
//       subFormAction: '',
//       touch: '02-28-18',
//       touchOther: '04-18-18'
//     },
//     {
//       Added_Time: '04-03-17 22:08:42',
//       Added_User: 'ensobase',
//       Address: '9223 Overland & 1725, 1725 2, 1730 Kimball , , , ',
//       Address1: '9223 Overland & 1725, 1725 2, 1730 Kimball',
//       Address2: '',
//       Asking_Price: ' 1,000,000.00',
//       Building_Size_SqFt: '',
//       Building_SpaceDOTBuilding_Space: [
//         '9223 Overland ',
//         '1725 Kimball ',
//         '1725 2 Kimball',
//         '1730 Kimball'
//       ],
//       City: '',
//       Deal_Type: ['Sale'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000050842240,
//       Land_Size_Acres: 7.55,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '03-22-18 10:12:36',
//       Modified_User: 'shannon.hull1',
//       Name: 'Overland & Kimball - Lots',
//       Notes: '',
//       Parcel_Number: 'SII23110385, S1123110330, S1123110300, S1123110280',
//       ParentID: 359246654,
//       Seller_Landlord: ['Don & Mary Thomas '],
//       Seller_LandlordDOTmyID: [358740746],
//       Space_SF: '',
//       State_Province: '',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Overland & Kimball - Lots&topParentID=359246654&tm_style=__due&cmd=&iList=Property&formID=243881000050842247&formMyID=359246654&formType=Property&iContactID=',
//       TopParentStatus: 'Active Prop',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: 'City of Boise R-1A',
//       cmd: '',
//       myID: 359246654,
//       subFormAction: '',
//       touch: '03-22-18',
//       touchOther: '03-22-18'
//     },
//     {
//       Added_Time: '03-29-17 11:54:00',
//       Added_User: 'shannon.hull1',
//       Address: '985 N. Meridian Rd. , Kuna, ID, 83634',
//       Address1: '985 N. Meridian Rd. ',
//       Address2: '',
//       Asking_Price: ' 400,000.00',
//       Building_Size_SqFt: '',
//       City: 'Kuna',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000050793000,
//       Land_Size_Acres: 0.67,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Taco Bell - Lot 3, Ensign ',
//       Notes: 'Address FKA 821 N. Meridian Rd.',
//       Parcel_Number: '',
//       ParentID: 361706050,
//       Seller_Landlord: ['Emmett Partners- LLC - Jeremy Terry Emmett Partners'],
//       Seller_LandlordDOTmyID: [379400699],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Taco Bell - Lot 3, Ensign &topParentID=361706050&tm_style=__due&cmd=&iList=Property&formID=243881000050793003&formMyID=361706050&formType=Property&iContactID=',
//       TopParentStatus: 'Active Prop',
//       Type: 'Land',
//       Zip_Postal_Code: '83634',
//       Zoning: '',
//       cmd: '',
//       myID: 361706050,
//       subFormAction: '',
//       touch: '07-24-17',
//       touchOther: '07-24-17'
//     },
//     {
//       Added_Time: '03-29-17 11:19:57',
//       Added_User: 'shannon.hull1',
//       Address: '1375 N. Happy Valley Rd. , Nampa, ID, 83687',
//       Address1: '1375 N. Happy Valley Rd.',
//       Address2: '',
//       Asking_Price: ' 1,500,000.00',
//       Building_Size_SqFt: 6931,
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000050792000,
//       Land_Size_Acres: 1.13,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Discount Tire - 1375 N. Happy Valley Rd.',
//       Notes: '',
//       Parcel_Number: 'R3108610100',
//       ParentID: 360180890,
//       Seller_Landlord: ['Halle Properties- LLC  Halle Properties- LLC'],
//       Seller_LandlordDOTmyID: [296039481],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Discount Tire - 1375 N. Happy Valley Rd.&topParentID=360180890&tm_style=__due&cmd=&iList=Property&formID=243881000050792003&formMyID=360180890&formType=Property&iContactID=',
//       TopParentStatus: 'Active Prop',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83687',
//       Zoning: '',
//       cmd: '',
//       myID: 360180890,
//       subFormAction: '',
//       touch: '06-27-17',
//       touchOther: '06-27-17'
//     },
//     {
//       Added_Time: '03-29-17 17:01:44',
//       Added_User: 'shannon.hull1',
//       Address: '2618 Blaine and 2701 Cleveland , Caldwell, ID, 83605',
//       Address1: '2618 Blaine and 2701 Cleveland ',
//       Address2: '',
//       Asking_Price: ' 1,650,000.00',
//       Building_Size_SqFt: '',
//       Building_SpaceDOTBuilding_Space: [
//         'R35345018A0',
//         'R3534501600',
//         'R3534501000',
//         'R3534501100'
//       ],
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000050791040,
//       Land_Size_Acres: 2.549,
//       Listing_Broker: ['Ryan Cantlon Idaho Commercial Brokerage- LLC'],
//       Listing_BrokerDOTmyID: [378996927],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Jacksons - Blaine and Cleveland ',
//       Notes: '',
//       Parcel_Number: 'R35345018A0 - R3534501600 - R3534501000 - R3534501100',
//       ParentID: 380365245,
//       Seller_Landlord: ['JSB Properties- LLC and Curt & Hal- Inc. '],
//       Seller_LandlordDOTmyID: [379087200],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Jacksons - Blaine and Cleveland &topParentID=380365245&tm_style=__due&cmd=&iList=Property&formID=243881000050791036&formMyID=380365245&formType=Property&iContactID=',
//       TopParentStatus: 'Active Prop',
//       Type: 'Land',
//       Zip_Postal_Code: '83605',
//       Zoning: '',
//       cmd: '',
//       myID: 380365245,
//       subFormAction: '',
//       touch: '10-24-17',
//       touchOther: '10-24-17'
//     },
//     {
//       Added_Time: '03-29-17 10:32:10',
//       Added_User: 'shannon.hull1',
//       Address: ' , Boise, ID, ',
//       Address1: '',
//       Address2: '',
//       Asking_Price: ' 3,306,297.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000050789120,
//       Land_Size_Acres: 11,
//       Listing_Broker: ['Peter Oliver Thornton Oliver Keller '],
//       Listing_BrokerDOTmyID: [357432534],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Barber Station - 11.467 Acres of Land',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 357189936,
//       Seller_Landlord: ['Barber Station Inc.  '],
//       Seller_LandlordDOTmyID: [357264678],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Barber Station - 11.467 Acres of Land&topParentID=357189936&tm_style=__due&cmd=&iList=Property&formID=243881000050789115&formMyID=357189936&formType=Property&iContactID=',
//       TopParentStatus: 'Active Prop',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 357189936,
//       subFormAction: '',
//       touch: '08-08-17',
//       touchOther: '08-08-17'
//     },
//     {
//       Added_Time: '03-22-17 13:59:42',
//       Added_User: 'shannon.hull1',
//       Address: '1752 W. Cherry Ln. , Meridian, ID, 83642',
//       Address1: '1752 W. Cherry Ln. ',
//       Address2: '',
//       Asking_Price: ' 635,000.00',
//       Building_Size_SqFt: 2485,
//       City: 'Meridian ',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000049776060,
//       Land_Size_Acres: 0.954,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Pizza Hut - 1752 W. Cherry Lane ',
//       Notes: '',
//       Parcel_Number: 'R138690151',
//       ParentID: 764671132,
//       Seller_Landlord: ['Carolyn Rich W &H LLC- PHI LLC'],
//       Seller_LandlordDOTmyID: [758337068],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut - 1752 W. Cherry Lane &topParentID=764671132&tm_style=__due&cmd=&iList=Property&formID=243881000049776061&formMyID=764671132&formType=Property&iContactID=',
//       TopParentStatus: 'Active Prop',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83642',
//       Zoning: 'City of Meridian C-N',
//       cmd: '',
//       myID: 764671132,
//       subFormAction: '',
//       touch: '06-27-17',
//       touchOther: '06-27-17'
//     },
//     {
//       Added_Time: '03-22-17 12:15:30',
//       Added_User: 'shannon.hull1',
//       Address: '1604 S. Broadway Ave. , Boise, ID, 83706',
//       Address1: '1604 S. Broadway Ave. ',
//       Address2: '',
//       Asking_Price: ' 1,314,285.00',
//       Building_Size_SqFt: 1352,
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000049776030,
//       Land_Size_Acres: 0.304,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Black Rock - 1604 S. Broadway Ave. ',
//       Notes: '',
//       Parcel_Number: 'R5315001842',
//       ParentID: 758680914,
//       Seller_Landlord: [
//         'Chris Lattanzio - Broadway PITA LLC Broadway PITA LLC'
//       ],
//       Seller_LandlordDOTmyID: [289673648],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Black Rock - 1604 S. Broadway Ave. &topParentID=758680914&tm_style=__due&cmd=&iList=Property&formID=243881000049776027&formMyID=758680914&formType=Property&iContactID=',
//       TopParentStatus: 'Active Prop',
//       Type: 'Investment',
//       Zip_Postal_Code: '83706',
//       Zoning: '',
//       cmd: '',
//       myID: 758680914,
//       subFormAction: '',
//       touch: '06-27-17',
//       touchOther: '06-27-17'
//     },
//     {
//       Added_Time: '03-22-17 12:10:37',
//       Added_User: 'shannon.hull1',
//       Address: '10659 Fairview Ave. , Boise, ID, 83713',
//       Address1: '10659 Fairview Ave.',
//       Address2: '',
//       Asking_Price: ' 525,000.00',
//       Building_Size_SqFt: 3023,
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000049776030,
//       Land_Size_Acres: 0.83,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '03-07-18 08:06:38',
//       Modified_User: 'shannon.hull1',
//       Name: 'Pizza Hut - 10659 Fairview Ave. ',
//       Notes:
//         'Code to get into building: 71284*\nBree has key in cabinet at front desk',
//       Parcel_Number: 'S1110110043',
//       ParentID: 758451934,
//       Seller_Landlord: ['B & S Investments LLC B & S Investments LLC'],
//       Seller_LandlordDOTmyID: [281144052],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Lease',
//       StatusDOTmyID: '144662939',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pizza Hut - 10659 Fairview Ave. &topParentID=758451934&tm_style=__due&cmd=&iList=Property&formID=243881000049776023&formMyID=758451934&formType=Property&iContactID=',
//       TopParentStatus: 'Active Prop',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '83713',
//       Zoning: 'City of Boise-C-2D',
//       cmd: '',
//       myID: 758451934,
//       subFormAction: '',
//       touch: '03-07-18',
//       touchOther: '03-07-18'
//     },
//     {
//       Added_Time: '03-22-17 11:46:10',
//       Added_User: 'shannon.hull1',
//       Address: '1000 Warm Springs Rd. , Ketchum, ID, 83340',
//       Address1: '1000 Warm Springs Rd.',
//       Address2: '',
//       Asking_Price: ' 3,495,000.00',
//       Building_Size_SqFt: '',
//       City: 'Ketchum ',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000049776000,
//       Land_Size_Acres: 2.43,
//       Listing_Broker: ['McCann Daech Fenton Realtors- LLC '],
//       Listing_BrokerDOTmyID: [757295180],
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'ABS - Ketchum',
//       Notes: '',
//       Parcel_Number: 'RPK4N170130970',
//       ParentID: 756274464,
//       Seller_Landlord: ['Verne W. Howard- Trustee  '],
//       Seller_LandlordDOTmyID: [756380484],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=ABS - Ketchum&topParentID=756274464&tm_style=__due&cmd=&iList=Property&formID=243881000049776007&formMyID=756274464&formType=Property&iContactID=',
//       TopParentStatus: 'Active Prop',
//       Type: 'Land',
//       Zip_Postal_Code: '83340',
//       Zoning: '',
//       cmd: '',
//       myID: 756274464,
//       subFormAction: '',
//       touch: '06-26-17',
//       touchOther: '06-26-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1756 W. Cherry Ln. Ste 110-120 , Meridian, ID, ',
//       Address1: '1756 W. Cherry Ln. Ste 110-120',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044444000,
//       Land_Size_Acres: 2.09,
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Cherry Crossing Plaza - Meridian',
//       Notes: '',
//       Parcel_Number: 'R1386910012',
//       ParentID: 101546,
//       Space_SF: 13728,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Cherry Crossing Plaza - Meridian&topParentID=101546&tm_style=__due&cmd=&iList=Property&formID=243881000044443993&formMyID=101546&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'City of Meridian C-N',
//       cmd: '',
//       myID: 101546,
//       subFormAction: '',
//       touch: '01-17-17',
//       touchOther: '01-17-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1435 N Happy Valley Rd Ste 1 , Nampa, ID, ',
//       Address1: '1435 N Happy Valley Rd Ste 1',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044444000,
//       Land_Size_Acres: 1.11,
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Pad 5 - Nampa',
//       Notes: '',
//       Parcel_Number: '3108600000 R3108610300',
//       ParentID: 99267,
//       Space_SF: 2600,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pad 5 - Nampa&topParentID=99267&tm_style=__due&cmd=&iList=Property&formID=243881000044443989&formMyID=99267&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 99267,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '7020 W. State St. , Boise, ID, ',
//       Address1: '7020 W. State St.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044444000,
//       Land_Size_Acres: 3.62,
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Rite Aid - Boise',
//       Notes: '',
//       Parcel_Number: 'R6120280050',
//       ParentID: 95789,
//       Space_SF: 39875,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Rite Aid - Boise&topParentID=95789&tm_style=__due&cmd=&iList=Property&formID=243881000044443985&formMyID=95789&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 95789,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3325 N Ten Mile Rd. Ste 150 , Meridian, ID, ',
//       Address1: '3325 N Ten Mile Rd. Ste 150',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443970,
//       Land_Size_Acres: 1.15,
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Ten Mile Plaza Retail & Office Space For Lease - Meridian',
//       Notes: '',
//       Parcel_Number: 'R5629430035',
//       ParentID: 107070,
//       Space_SF: 9328,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Ten Mile Plaza Retail & Office Space For Lease - Meridian&topParentID=107070&tm_style=__due&cmd=&iList=Property&formID=243881000044443981&formMyID=107070&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-G',
//       cmd: '',
//       myID: 107070,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '10015 W. State St. , Garden City, ID, ',
//       Address1: '10015 W. State St.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Garden City',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443970,
//       Land_Size_Acres: 1.08,
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'The Human Bean Boise - Garden City',
//       Notes: '',
//       Parcel_Number: 'S0514346700',
//       ParentID: 106758,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=The Human Bean Boise - Garden City&topParentID=106758&tm_style=__due&cmd=&iList=Property&formID=243881000044443977&formMyID=106758&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'City of Garden City-C-2',
//       cmd: '',
//       myID: 106758,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1850 Caldwell Blvd. , Nampa, ID, ',
//       Address1: '1850 Caldwell Blvd.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443970,
//       Land_Size_Acres: '',
//       Modified_Time: '12-18-17 00:00:05',
//       Modified_User: 'ensobase',
//       Name: 'Nampa Canyon Plaza - Nampa',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 89621,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Nampa Canyon Plaza - Nampa&topParentID=89621&tm_style=__due&cmd=&iList=Property&formID=243881000044443973&formMyID=89621&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 89621,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '5725-5761 W Fairview Ave Ste 5725 , Boise, ID, ',
//       Address1: '5725-5761 W Fairview Ave Ste 5725',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443970,
//       Land_Size_Acres: 1.88,
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Fairview Shopping Center - Boise',
//       Notes: '',
//       Parcel_Number: 'S1008223100',
//       ParentID: 102050,
//       Space_SF: 27199,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Fairview Shopping Center - Boise&topParentID=102050&tm_style=__due&cmd=&iList=Property&formID=243881000044443969&formMyID=102050&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'L-ODDA',
//       cmd: '',
//       myID: 102050,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '7660 W. State St. , Boise, ID, ',
//       Address1: '7660 W. State St.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443970,
//       Land_Size_Acres: 23.14,
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Northpointe - Boise',
//       Notes: '',
//       Parcel_Number: 'R3046750025 R6122920020 R6122920030 R6122920040',
//       ParentID: 114622,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Northpointe - Boise&topParentID=114622&tm_style=__due&cmd=&iList=Property&formID=243881000044443965&formMyID=114622&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-4DDA',
//       cmd: '',
//       myID: 114622,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '828 W. Idaho St. , Boise, ID, ',
//       Address1: '828 W. Idaho St.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443970,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Sara Shropshire CWP'],
//       Listing_BrokerDOTmyID: [243888],
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Downtown Boise Retail  Restaurant Space For Lease - Boise',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 104255,
//       Space_SF: 1008,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Downtown Boise Retail  Restaurant Space For Lease - Boise&topParentID=104255&tm_style=__due&cmd=&iList=Property&formID=243881000044443961&formMyID=104255&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'City of Boise-C-5DD',
//       cmd: '',
//       myID: 104255,
//       subFormAction: '',
//       touch: '01-16-17',
//       touchOther: '01-16-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '515 Cleveland Blvd Ste 1 , Caldwell, ID, ',
//       Address1: '515 Cleveland Blvd Ste 1',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443970,
//       Land_Size_Acres: 0.62,
//       Listing_Broker: ['Andrea Nilson CWP', 'Sara Shropshire CWP'],
//       Listing_BrokerDOTmyID: [243881, 243888],
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'High Visibility Retail  Office Space For Lease - Caldwell',
//       Notes: '',
//       Parcel_Number: 'R468700000',
//       ParentID: 102583,
//       Space_SF: 4936,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=High Visibility Retail  Office Space For Lease - Caldwell&topParentID=102583&tm_style=__due&cmd=&iList=Property&formID=243881000044443957&formMyID=102583&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 102583,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1217-1233 S Broadway Ave Ste D , Boise, ID, ',
//       Address1: '1217-1233 S Broadway Ave Ste D',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443970,
//       Land_Size_Acres: 3.49,
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Broadway Shopping Center - Boise',
//       Notes: '',
//       Parcel_Number: 'R8048012342 R8048013008',
//       ParentID: 83882,
//       Space_SF: 48042,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Broadway Shopping Center - Boise&topParentID=83882&tm_style=__due&cmd=&iList=Property&formID=243881000044443953&formMyID=83882&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'R-3D',
//       cmd: '',
//       myID: 83882,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '5205 Cleveland Blvd. Ste 100 , Caldwell, ID, ',
//       Address1: '5205 Cleveland Blvd. Ste 100',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443940,
//       Land_Size_Acres: 2.15,
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Shops on the Boulevard - Caldwell',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 87490,
//       Space_SF: 9600,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Shops on the Boulevard - Caldwell&topParentID=87490&tm_style=__due&cmd=&iList=Property&formID=243881000044443949&formMyID=87490&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 87490,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '6728 W State St , Boise, ID, ',
//       Address1: '6728 W State St',
//       Address2: '',
//       Asking_Price: ' 618,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443940,
//       Land_Size_Acres: 0.7,
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: '6728 W State - Boise',
//       Notes: '',
//       Parcel_Number: 'S0619336441',
//       ParentID: 99907,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=6728 W State - Boise&topParentID=99907&tm_style=__due&cmd=&iList=Property&formID=243881000044443945&formMyID=99907&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 99907,
//       subFormAction: '',
//       touch: '02-17-17',
//       touchOther: '02-17-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '300-344 W State St , Eagle, ID, ',
//       Address1: '300-344 W State St',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Eagle',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443940,
//       Land_Size_Acres: 3.24,
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Eagle Towne Plaza - Eagle',
//       Notes: '',
//       Parcel_Number: 'S0508417450',
//       ParentID: 111789,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Eagle Towne Plaza - Eagle&topParentID=111789&tm_style=__due&cmd=&iList=Property&formID=243881000044443941&formMyID=111789&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-BD',
//       cmd: '',
//       myID: 111789,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1569 N. Milwaukee Rd. , Boise, ID, ',
//       Address1: '1569 N. Milwaukee Rd.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443940,
//       Land_Size_Acres: 3.64,
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Fairview Milwaukee - Boise',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 85896,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Fairview Milwaukee - Boise&topParentID=85896&tm_style=__due&cmd=&iList=Property&formID=243881000044443937&formMyID=85896&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 85896,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3223 E Louise Dr Ste 106 , Meridian, ID, ',
//       Address1: '3223 E Louise Dr Ste 106',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443940,
//       Land_Size_Acres: 1.29,
//       Listing_Broker: ['Sara Shropshire CWP'],
//       Listing_BrokerDOTmyID: [243888],
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'The Portico at Meridian - Meridian',
//       Notes: '',
//       Parcel_Number: 'R3037460810',
//       ParentID: 101347,
//       Space_SF: 21950,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=The Portico at Meridian - Meridian&topParentID=101347&tm_style=__due&cmd=&iList=Property&formID=243881000044443933&formMyID=101347&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-G',
//       cmd: '',
//       myID: 101347,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '601 S Main St , Meridian, ID, ',
//       Address1: '601 S Main St',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443940,
//       Land_Size_Acres: 1.08,
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: '*missing name* - Meridian',
//       Notes: '',
//       Parcel_Number: 'S1118233831',
//       ParentID: 43565,
//       Space_SF: 3200,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=*missing name* - Meridian&topParentID=43565&tm_style=__due&cmd=&iList=Property&formID=243881000044443929&formMyID=43565&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-G',
//       cmd: '',
//       myID: 43565,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '4023 Yellowstone , Chubbuck, ID, ',
//       Address1: '4023 Yellowstone',
//       Address2: '',
//       Asking_Price: ' 2,610,000.00',
//       Building_Size_SqFt: '',
//       City: 'Chubbuck',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443940,
//       Land_Size_Acres: 0.66,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Single Tenant NNN Leased Investment - Chubbuck',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 115145,
//       Space_SF: 2746,
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Single Tenant NNN Leased Investment - Chubbuck&topParentID=115145&tm_style=__due&cmd=&iList=Property&formID=243881000044443925&formMyID=115145&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 115145,
//       subFormAction: '',
//       touch: '03-14-17',
//       touchOther: '03-14-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '42 N. 2nd E. , Rexburg, ID, ',
//       Address1: '42 N. 2nd E.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Rexburg',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443940,
//       Land_Size_Acres: 1,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Retail Spaces Available for Lease & BTS - Rexburg',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 110199,
//       Space_SF: 7500,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Retail Spaces Available for Lease & BTS - Rexburg&topParentID=110199&tm_style=__due&cmd=&iList=Property&formID=243881000044443921&formMyID=110199&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 110199,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1467 & 1503 Caldwell Blvd. Ste 1467 & 1503 , Nampa, ID, ',
//       Address1: '1467 & 1503 Caldwell Blvd. Ste 1467 & 1503',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443900,
//       Land_Size_Acres: '',
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Retail Shop Spaces For Lease - Nampa',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 109204,
//       Space_SF: 2400,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Retail Shop Spaces For Lease - Nampa&topParentID=109204&tm_style=__due&cmd=&iList=Property&formID=243881000044443917&formMyID=109204&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 109204,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1305 N. Happy Valley Rd. , Nampa, ID, ',
//       Address1: '1305 N. Happy Valley Rd.',
//       Address2: '',
//       Asking_Price: ' 1,000,000.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443900,
//       Land_Size_Acres: 1.78,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: "Freddy's Popeyes - Nampa",
//       Notes: '',
//       Parcel_Number: 'R31086102A0',
//       ParentID: 106406,
//       Seller_Landlord: ['DDR Nampa - LLC DDR Corp.'],
//       Seller_LandlordDOTmyID: [757170433],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Freddy%27s Popeyes - Nampa&topParentID=106406&tm_style=__due&cmd=&iList=Property&formID=243881000044443913&formMyID=106406&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: 'C-1',
//       cmd: '',
//       myID: 106406,
//       subFormAction: '',
//       touch: '11-14-17',
//       touchOther: '08-25-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1471 Caldwell Blvd Ste 1471 , Nampa, ID, ',
//       Address1: '1471 Caldwell Blvd Ste 1471',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443900,
//       Land_Size_Acres: 37.22,
//       Listing_Broker: ['LeAnn Hume CWP', 'Sara Shropshire CWP'],
//       Listing_BrokerDOTmyID: [243885, 243888],
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Karcher Gateway - Nampa',
//       Notes: '',
//       Parcel_Number: 'R1214300000',
//       ParentID: 105304,
//       Space_SF: 8339,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Karcher Gateway - Nampa&topParentID=105304&tm_style=__due&cmd=&iList=Property&formID=243881000044443909&formMyID=105304&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 105304,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '110 E Myrtle St Ste 1 , Boise, ID, ',
//       Address1: '110 E Myrtle St Ste 1',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443900,
//       Land_Size_Acres: 7.5,
//       Listing_Broker: ['LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243885],
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'WinCo Foods - Boise',
//       Notes: '',
//       Parcel_Number: 'R6907250012',
//       ParentID: 101666,
//       Space_SF: 79969,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=WinCo Foods - Boise&topParentID=101666&tm_style=__due&cmd=&iList=Property&formID=243881000044443905&formMyID=101666&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'R-ODD',
//       cmd: '',
//       myID: 101666,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1045 Yellowstone Ave. , Pocatello, ID, ',
//       Address1: '1045 Yellowstone Ave.',
//       Address2: '',
//       Asking_Price: ' 450,000.00',
//       Building_Size_SqFt: '',
//       City: 'Pocatello',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443900,
//       Land_Size_Acres: 0.21,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:04',
//       Modified_User: 'ensobase',
//       Name: 'Bank Branch For Sale - Pocatello',
//       Notes: '',
//       Parcel_Number: 'RPGNA000600',
//       ParentID: 97977,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Bank Branch For Sale - Pocatello&topParentID=97977&tm_style=__due&cmd=&iList=Property&formID=243881000044443901&formMyID=97977&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 97977,
//       subFormAction: '',
//       touch: '10-31-17',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1100 W Front St , Boise, ID, ',
//       Address1: '1100 W Front St',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443900,
//       Land_Size_Acres: 0.13,
//       Listing_Broker: ['Andrea Nilson CWP', 'LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243881, 243885],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Downtown Retail Space - Boise',
//       Notes: '',
//       Parcel_Number: 'R1013001466',
//       ParentID: 83826,
//       Space_SF: 1704,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Downtown Retail Space - Boise&topParentID=83826&tm_style=__due&cmd=&iList=Property&formID=243881000044443893&formMyID=83826&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-5DD',
//       cmd: '',
//       myID: 83826,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3520 W Chinden Blvd Ste 1 , Garden City, ID, ',
//       Address1: '3520 W Chinden Blvd Ste 1',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Garden City',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443900,
//       Land_Size_Acres: 0.3,
//       Listing_Broker: ['LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243885],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Professional Office & Retail Space - Garden City',
//       Notes: '',
//       Parcel_Number: 'R2734540021',
//       ParentID: 83525,
//       Space_SF: 6387,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Professional Office & Retail Space - Garden City&topParentID=83525&tm_style=__due&cmd=&iList=Property&formID=243881000044443889&formMyID=83525&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C1',
//       cmd: '',
//       myID: 83525,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1305 Broadway Ave. , Boise, ID, ',
//       Address1: '1305 Broadway Ave.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443870,
//       Land_Size_Acres: 0.29,
//       Listing_Broker: ['Andrea Nilson CWP', 'LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243881, 243885],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '1305 Broadway Avenue - Boise',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 81359,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=1305 Broadway Avenue - Boise&topParentID=81359&tm_style=__due&cmd=&iList=Property&formID=243881000044443885&formMyID=81359&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 81359,
//       subFormAction: '',
//       touch: '06-30-17',
//       touchOther: '06-30-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3020 Cleveland Blvd , Caldwell, ID, ',
//       Address1: '3020 Cleveland Blvd',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443870,
//       Land_Size_Acres: 1.04,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Retail & Restaurant Pad or Building - Caldwell',
//       Notes: '',
//       Parcel_Number: 'R0406900000',
//       ParentID: 122095,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Retail & Restaurant Pad or Building - Caldwell&topParentID=122095&tm_style=__due&cmd=&iList=Property&formID=243881000044443881&formMyID=122095&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-3',
//       cmd: '',
//       myID: 122095,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2025 12th Ave Ste 130 , Nampa, ID, ',
//       Address1: '2025 12th Ave Ste 130',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443870,
//       Land_Size_Acres: 0.9,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '2025 12th Ave Road - Nampa',
//       Notes: '',
//       Parcel_Number: '32170010A0',
//       ParentID: 89785,
//       Space_SF: 7419,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=2025 12th Ave Road - Nampa&topParentID=89785&tm_style=__due&cmd=&iList=Property&formID=243881000044443877&formMyID=89785&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 89785,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '182 Blue Lakes Blvd North Ste 10 , Twin Falls, ID, ',
//       Address1: '182 Blue Lakes Blvd North Ste 10',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Twin Falls',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443870,
//       Land_Size_Acres: 1.2,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '*missing name* - Twin Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 121831,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=*missing name* - Twin Falls&topParentID=121831&tm_style=__due&cmd=&iList=Property&formID=243881000044443873&formMyID=121831&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 121831,
//       subFormAction: '',
//       touch: '06-30-17',
//       touchOther: '06-30-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '509-517 E Highland St , Boise, ID, ',
//       Address1: '509-517 E Highland St',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443870,
//       Land_Size_Acres: 0.82,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '509_517 Highland St - Boise',
//       Notes: '',
//       Parcel_Number: 'R3616580350',
//       ParentID: 42764,
//       Space_SF: 6549,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=509_517 Highland St - Boise&topParentID=42764&tm_style=__due&cmd=&iList=Property&formID=243881000044443869&formMyID=42764&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'R-1B',
//       cmd: '',
//       myID: 42764,
//       subFormAction: '',
//       touch: '01-26-17',
//       touchOther: '01-26-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '4500 W Overland Rd Ste Space 8 , Boise, ID, ',
//       Address1: '4500 W Overland Rd Ste Space 8',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443870,
//       Land_Size_Acres: 4,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Country Club Retail Plaza - Boise',
//       Notes: '',
//       Parcel_Number: 'R4936000006',
//       ParentID: 118967,
//       Space_SF: 64399,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Country Club Retail Plaza - Boise&topParentID=118967&tm_style=__due&cmd=&iList=Property&formID=243881000044443865&formMyID=118967&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C2D',
//       cmd: '',
//       myID: 118967,
//       subFormAction: '',
//       touch: '01-17-17',
//       touchOther: '01-17-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1217-1255 S Broadway Ave Ste 101 , Boise, ID, ',
//       Address1: '1217-1255 S Broadway Ave Ste 101',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443870,
//       Land_Size_Acres: 3.49,
//       Listing_Broker: ['Sara Shropshire CWP'],
//       Listing_BrokerDOTmyID: [243888],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Broadway Center - Boise',
//       Notes: '',
//       Parcel_Number: 'R8048012342 R8048013008',
//       ParentID: 95008,
//       Space_SF: 50000,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Broadway Center - Boise&topParentID=95008&tm_style=__due&cmd=&iList=Property&formID=243881000044443861&formMyID=95008&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'R-3D',
//       cmd: '',
//       myID: 95008,
//       subFormAction: '',
//       touch: '01-26-17',
//       touchOther: '01-26-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2500 E 17th St Ste Pad H , Idaho Falls, ID, ',
//       Address1: '2500 E 17th St Ste Pad H',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Idaho Falls',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443870,
//       Land_Size_Acres: 0,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Grand Teton Mall - Idaho Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 102979,
//       Space_SF: 540000,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Grand Teton Mall - Idaho Falls&topParentID=102979&tm_style=__due&cmd=&iList=Property&formID=243881000044443857&formMyID=102979&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 102979,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1312 S Washington Ave , Emmett, ID, ',
//       Address1: '1312 S Washington Ave',
//       Address2: '',
//       Asking_Price: ' 1,450,000.00',
//       Building_Size_SqFt: '',
//       City: 'Emmett',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443840,
//       Land_Size_Acres: 1.36,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Gem Retail Center - Emmett',
//       Notes: '',
//       Parcel_Number: 'RP00188601',
//       ParentID: 41574,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Gem Retail Center - Emmett&topParentID=41574&tm_style=__due&cmd=&iList=Property&formID=243881000044443853&formMyID=41574&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 41574,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '6939 W State St , Boise, ID, ',
//       Address1: '6939 W State St',
//       Address2: '',
//       Asking_Price: ' 300,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443840,
//       Land_Size_Acres: 0.99,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Super Wash Car Wash - Boise',
//       Notes: '',
//       Parcel_Number: 'S0524449402',
//       ParentID: 90441,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Super Wash Car Wash - Boise&topParentID=90441&tm_style=__due&cmd=&iList=Property&formID=243881000044443849&formMyID=90441&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2',
//       cmd: '',
//       myID: 90441,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '650 W. 8th St. , Mountain Home, ID, ',
//       Address1: '650 W. 8th St.',
//       Address2: '',
//       Asking_Price: ' 22.00',
//       Building_Size_SqFt: '',
//       City: 'Mountain Home',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443840,
//       Land_Size_Acres: 2.45,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '650 W 8th St - Mountain Home',
//       Notes: '',
//       Parcel_Number: 'RPA3S06E351139A',
//       ParentID: 97450,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=650 W 8th St - Mountain Home&topParentID=97450&tm_style=__due&cmd=&iList=Property&formID=243881000044443845&formMyID=97450&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 97450,
//       subFormAction: '',
//       touch: '03-14-17',
//       touchOther: '03-14-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '201 W Ustick Rd , Meridian, ID, ',
//       Address1: '201 W Ustick Rd',
//       Address2: '',
//       Asking_Price: ' 950,000.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443840,
//       Land_Size_Acres: 5.54,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Meridian Churchschool - Meridian',
//       Notes: '',
//       Parcel_Number: 'R8189830012',
//       ParentID: 41516,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Meridian Churchschool - Meridian&topParentID=41516&tm_style=__due&cmd=&iList=Property&formID=243881000044443841&formMyID=41516&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'L-O',
//       cmd: '',
//       myID: 41516,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '535 N Milwaukee St , Boise, ID, ',
//       Address1: '535 N Milwaukee St',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443840,
//       Land_Size_Acres: 0.57,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Noodles & Company - Boise',
//       Notes: '',
//       Parcel_Number: 'R9316720075',
//       ParentID: 82707,
//       Space_SF: 3455,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Noodles & Company - Boise&topParentID=82707&tm_style=__due&cmd=&iList=Property&formID=243881000044443837&formMyID=82707&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 82707,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '106 N 6th St Ste C , Boise, ID, ',
//       Address1: '106 N 6th St Ste C',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443840,
//       Land_Size_Acres: 0.43,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Pioneer Building - Boise',
//       Notes: '',
//       Parcel_Number: 'R1013000350',
//       ParentID: 103363,
//       Space_SF: 30000,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pioneer Building - Boise&topParentID=103363&tm_style=__due&cmd=&iList=Property&formID=243881000044443833&formMyID=103363&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-5HD',
//       cmd: '',
//       myID: 103363,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1900 Blue Lakes Blvd. Ste 1 , Twin Falls, ID, ',
//       Address1: '1900 Blue Lakes Blvd. Ste 1',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Twin Falls',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443840,
//       Land_Size_Acres: '',
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Canyon Park West - Twin Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 107440,
//       Space_SF: 200000,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Canyon Park West - Twin Falls&topParentID=107440&tm_style=__due&cmd=&iList=Property&formID=243881000044443829&formMyID=107440&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 107440,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2110 Blaine St , Caldwell, ID, ',
//       Address1: '2110 Blaine St',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443840,
//       Land_Size_Acres: 0.21,
//       Listing_Broker: ['Andrea Nilson CWP'],
//       Listing_BrokerDOTmyID: [243881],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Pita Bean Caldwell',
//       Notes: '',
//       Parcel_Number: 'R36800000',
//       ParentID: 96754,
//       Space_SF: 3881,
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pita Bean Caldwell&topParentID=96754&tm_style=__due&cmd=&iList=Property&formID=243881000044443825&formMyID=96754&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 96754,
//       subFormAction: '',
//       touch: '03-28-17',
//       touchOther: '03-28-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3340 N Eagle Rd Ste 260 , Meridian, ID, ',
//       Address1: '3340 N Eagle Rd Ste 260',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443800,
//       Land_Size_Acres: 1.89,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Shops at Ustick Marketplace - Meridian',
//       Notes: '',
//       Parcel_Number: 'R7991130040',
//       ParentID: 43308,
//       Space_SF: 10030,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Shops at Ustick Marketplace - Meridian&topParentID=43308&tm_style=__due&cmd=&iList=Property&formID=243881000044443821&formMyID=43308&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-G',
//       cmd: '',
//       myID: 43308,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2540 E. Sunnyside Rd. , Idaho Falls, ID, ',
//       Address1: '2540 E. Sunnyside Rd.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Idaho Falls',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443800,
//       Land_Size_Acres: '',
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Sandcreek Commons - Idaho Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 109391,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Sandcreek Commons - Idaho Falls&topParentID=109391&tm_style=__due&cmd=&iList=Property&formID=243881000044443813&formMyID=109391&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 109391,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '210-224 N 9th St , Boise, ID, ',
//       Address1: '210-224 N 9th St',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443800,
//       Land_Size_Acres: 0.28,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Jordan Building - Boise',
//       Notes: '',
//       Parcel_Number: 'R1013002957',
//       ParentID: 43709,
//       Space_SF: 4746,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Jordan Building - Boise&topParentID=43709&tm_style=__due&cmd=&iList=Property&formID=243881000044443809&formMyID=43709&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-5DD',
//       cmd: '',
//       myID: 43709,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3367 Federal Way West , Boise, ID, ',
//       Address1: '3367 Federal Way West',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443800,
//       Land_Size_Acres: 0.73,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Federal Way Retail Shop - Boise',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 122774,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Federal Way Retail Shop - Boise&topParentID=122774&tm_style=__due&cmd=&iList=Property&formID=243881000044443805&formMyID=122774&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 122774,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1326 S Broadway Ave , Boise, ID, ',
//       Address1: '1326 S Broadway Ave',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443800,
//       Land_Size_Acres: 0.35,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Flying Pie Pizzeria - Boise',
//       Notes: '',
//       Parcel_Number: 'R5315000500',
//       ParentID: 105017,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Flying Pie Pizzeria - Boise&topParentID=105017&tm_style=__due&cmd=&iList=Property&formID=243881000044443801&formMyID=105017&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 105017,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '6855-7165 W Overland Rd. Ste 6969 , Boise, ID, ',
//       Address1: '6855-7165 W Overland Rd. Ste 6969',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443800,
//       Land_Size_Acres: 1.06,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Overland Park Center - Boise',
//       Notes: '',
//       Parcel_Number: 'R6744640155',
//       ParentID: 93692,
//       Space_SF: 76004,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Overland Park Center - Boise&topParentID=93692&tm_style=__due&cmd=&iList=Property&formID=243881000044443797&formMyID=93692&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 93692,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '13530 W. Baldcypress St. , Boise, ID, ',
//       Address1: '13530 W. Baldcypress St.',
//       Address2: '',
//       Asking_Price: ' 1,035,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443800,
//       Land_Size_Acres: 0.65,
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: '*missing name* - Boise',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 84804,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=*missing name* - Boise&topParentID=84804&tm_style=__due&cmd=&iList=Property&formID=243881000044443793&formMyID=84804&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-1D',
//       cmd: '',
//       myID: 84804,
//       subFormAction: '',
//       touch: '06-30-17',
//       touchOther: '06-30-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '975 Meridian Road , Kuna, ID, ',
//       Address1: '975 Meridian Road',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Kuna',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443780,
//       Land_Size_Acres: '',
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Kuna Plaza - Kuna',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 122205,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Kuna Plaza - Kuna&topParentID=122205&tm_style=__due&cmd=&iList=Property&formID=243881000044443789&formMyID=122205&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 122205,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '8610-8664 W Overland Rd Ste 8636 , Boise, ID, ',
//       Address1: '8610-8664 W Overland Rd Ste 8636',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443780,
//       Land_Size_Acres: 4.07,
//       Listing_Broker: ['Andrea Nilson CWP'],
//       Listing_BrokerDOTmyID: [243881],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Overland Market Retail Space - Boise',
//       Notes: '',
//       Parcel_Number: 'S1113336007',
//       ParentID: 112904,
//       Space_SF: 24303,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Overland Market Retail Space - Boise&topParentID=112904&tm_style=__due&cmd=&iList=Property&formID=243881000044443785&formMyID=112904&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2',
//       cmd: '',
//       myID: 112904,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '817-821 N. Meridian Rd. Ste Retail Pad 2 , Kuna, ID, ',
//       Address1: '817-821 N. Meridian Rd. Ste Retail Pad 2',
//       Address2: '',
//       Asking_Price: ' 275,000.00',
//       Building_Size_SqFt: '',
//       City: 'Kuna',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443780,
//       Land_Size_Acres: 17.25,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Meridian Road Retail For Sale, Lease & BTS - Kuna',
//       Notes: '',
//       Parcel_Number: 'S1324141801',
//       ParentID: 117337,
//       Space_SF: 50000,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Meridian Road Retail For Sale, Lease & BTS - Kuna&topParentID=117337&tm_style=__due&cmd=&iList=Property&formID=243881000044443781&formMyID=117337&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 117337,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2110 Blaine St , Caldwell, ID, ',
//       Address1: '2110 Blaine St',
//       Address2: '',
//       Asking_Price: ' 1,300,000.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443780,
//       Land_Size_Acres: 0.21,
//       Listing_Broker: ['Andrea Nilson CWP'],
//       Listing_BrokerDOTmyID: [243881],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Pita Bean Calwell',
//       Notes: '',
//       Parcel_Number: 'R0036800000 & R0036700000',
//       ParentID: 97811,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pita Bean Calwell&topParentID=97811&tm_style=__due&cmd=&iList=Property&formID=243881000044443777&formMyID=97811&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: 'Land',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 97811,
//       subFormAction: '',
//       touch: '03-22-17',
//       touchOther: '03-22-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1789 S Broadway Ave , Boise, ID, ',
//       Address1: '1789 S Broadway Ave',
//       Address2: '',
//       Asking_Price: ' 850,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443780,
//       Land_Size_Acres: 0.72,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Office  Retail  Restaurant for Lease & BTS - Boise',
//       Notes: '',
//       Parcel_Number: 'R1955001607',
//       ParentID: 103148,
//       Space_SF: 5169,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Office  Retail  Restaurant for Lease & BTS - Boise&topParentID=103148&tm_style=__due&cmd=&iList=Property&formID=243881000044443773&formMyID=103148&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'L-OD',
//       cmd: '',
//       myID: 103148,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3132 S Bown Way Ste 3132 , Boise, ID, ',
//       Address1: '3132 S Bown Way Ste 3132',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443780,
//       Land_Size_Acres: 2,
//       Listing_Broker: ['Andrea Nilson CWP', 'Sara Shropshire CWP'],
//       Listing_BrokerDOTmyID: [243881, 243888],
//       Modified_Time: '12-18-17 00:00:03',
//       Modified_User: 'ensobase',
//       Name: 'Bown Crossing - Boise',
//       Notes: '',
//       Parcel_Number: 'R7476780020',
//       ParentID: 95237,
//       Space_SF: 12994,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Bown Crossing - Boise&topParentID=95237&tm_style=__due&cmd=&iList=Property&formID=243881000044443769&formMyID=95237&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'PC-D',
//       cmd: '',
//       myID: 95237,
//       subFormAction: '',
//       touch: '01-26-17',
//       touchOther: '01-26-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '780 Highway 93 , Challis, ID, ',
//       Address1: '780 Highway 93',
//       Address2: '',
//       Asking_Price: ' 1,003,584.00',
//       Building_Size_SqFt: '',
//       City: 'Challis',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443780,
//       Land_Size_Acres: 1.07,
//       Listing_Broker: ['Andrea Nilson CWP'],
//       Listing_BrokerDOTmyID: [243881],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Family Dollar - Challis',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 91480,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Family Dollar - Challis&topParentID=91480&tm_style=__due&cmd=&iList=Property&formID=243881000044443765&formMyID=91480&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 91480,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2242 S. Riverwalk Dr. Ste 101 , Boise, ID, ',
//       Address1: '2242 S. Riverwalk Dr. Ste 101',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443780,
//       Land_Size_Acres: 2,
//       Listing_Broker: ['Andrea Nilson CWP', 'Sara Shropshire CWP'],
//       Listing_BrokerDOTmyID: [243881, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Bown Crossing Retail & Office Space - Boise',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 84829,
//       Space_SF: 6557,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Bown Crossing Retail & Office Space - Boise&topParentID=84829&tm_style=__due&cmd=&iList=Property&formID=243881000044443761&formMyID=84829&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'PCD',
//       cmd: '',
//       myID: 84829,
//       subFormAction: '',
//       touch: '01-26-17',
//       touchOther: '01-26-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '7020 W. State St. , Boise, ID, ',
//       Address1: '7020 W. State St.',
//       Address2: '',
//       Asking_Price: ' 1,900,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443740,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Andrea Nilson CWP'],
//       Listing_BrokerDOTmyID: [243881],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: '7020 West State Street - Boise',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 82728,
//       Space_SF: 39875,
//       State_Province: 'ID',
//       Status: 'Comp - Retail',
//       StatusDOTmyID: '202068480',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=7020 West State Street - Boise&topParentID=82728&tm_style=__due&cmd=&iList=Property&formID=243881000044443757&formMyID=82728&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Retail ',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 82728,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2110 Blaine St , Caldwell, ID, ',
//       Address1: '2110 Blaine St',
//       Address2: '',
//       Asking_Price: ' 100,000.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443740,
//       Land_Size_Acres: 0.21,
//       Listing_Broker: ['Andrea Nilson CWP'],
//       Listing_BrokerDOTmyID: [243881],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Pita Bean Calwell',
//       Notes: '',
//       Parcel_Number: '36800000',
//       ParentID: 96636,
//       Space_SF: 3881,
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pita Bean Calwell&topParentID=96636&tm_style=__due&cmd=&iList=Property&formID=243881000044443753&formMyID=96636&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 96636,
//       subFormAction: '',
//       touch: '03-09-17',
//       touchOther: '03-09-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3377 N. Ten Mile Road , Meridian, ID, ',
//       Address1: '3377 N. Ten Mile Road',
//       Address2: '',
//       Asking_Price: ' 312,500.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443740,
//       Land_Size_Acres: '',
//       Listing_Broker: ['Andrea Nilson CWP', 'LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243881, 243885],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: '3377 North Ten Mile Road - Meridian',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 82598,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=3377 North Ten Mile Road - Meridian&topParentID=82598&tm_style=__due&cmd=&iList=Property&formID=243881000044443749&formMyID=82598&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 82598,
//       subFormAction: '',
//       touch: '01-12-17',
//       touchOther: '01-12-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '5023 Cleveland Blvd , Caldwell, ID, ',
//       Address1: '5023 Cleveland Blvd',
//       Address2: '',
//       Asking_Price: ' 1,550,000.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443740,
//       Land_Size_Acres: 7.23,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Lots 1 & 5_10 Caldwell Commons - Caldwell',
//       Notes: '',
//       Parcel_Number: 'R358930000',
//       ParentID: 99376,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Lots 1 & 5_10 Caldwell Commons - Caldwell&topParentID=99376&tm_style=__due&cmd=&iList=Property&formID=243881000044443745&formMyID=99376&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 99376,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2143 S. Broadway Ave. , Boise, ID, ',
//       Address1: '2143 S. Broadway Ave.',
//       Address2: '',
//       Asking_Price: ' 299,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443740,
//       Land_Size_Acres: 0.84,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Pinon Square - Boise',
//       Notes: '',
//       Parcel_Number: 'R3080770090',
//       ParentID: 107055,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pinon Square - Boise&topParentID=107055&tm_style=__due&cmd=&iList=Property&formID=243881000044443741&formMyID=107055&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'City of Boise-C-2D',
//       cmd: '',
//       myID: 107055,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '0 NWC Woodruff Ave & 1st St. Ste Pad , Idaho Falls, ID, ',
//       Address1: '0 NWC Woodruff Ave & 1st St. Ste Pad',
//       Address2: '',
//       Asking_Price: ' 575,000.00',
//       Building_Size_SqFt: '',
//       City: 'Idaho Falls',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443740,
//       Land_Size_Acres: 1,
//       Listing_Broker: ['LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243885],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'NWC Woodruff Ave & 1st - Idaho Falls',
//       Notes: '',
//       Parcel_Number: 'RPA10700010070',
//       ParentID: 80978,
//       Space_SF: 166399,
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=NWC Woodruff Ave & 1st - Idaho Falls&topParentID=80978&tm_style=__due&cmd=&iList=Property&formID=243881000044443737&formMyID=80978&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'RSC-1',
//       cmd: '',
//       myID: 80978,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3020 Cleveland Blvd , Caldwell, ID, ',
//       Address1: '3020 Cleveland Blvd',
//       Address2: '',
//       Asking_Price: ' 800,000.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443740,
//       Land_Size_Acres: 1.04,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: '3020 Cleveland - Multi-Tenant - Lattanzio',
//       Notes: '',
//       Parcel_Number: 'R0406900000',
//       ParentID: 41554,
//       Seller_Landlord: ['Chris Lattanzio - Cleveland 3020 LP '],
//       Seller_LandlordDOTmyID: [996764784],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=3020 Cleveland - Multi-Tenant - Lattanzio&topParentID=41554&tm_style=__due&cmd=&iList=Property&formID=243881000044443733&formMyID=41554&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: 'Multi-Tenant',
//       Zip_Postal_Code: '',
//       Zoning: 'C-3',
//       cmd: '',
//       myID: 41554,
//       subFormAction: '',
//       touch: '01-08-18',
//       touchOther: ''
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '0 Pole Line Road and Parkview Dr. Ste 2 , Twin Falls, ID, ',
//       Address1: '0 Pole Line Road and Parkview Dr. Ste 2',
//       Address2: '',
//       Asking_Price: ' 615,000.00',
//       Building_Size_SqFt: '',
//       City: 'Twin Falls',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443740,
//       Land_Size_Acres: 1.07,
//       Listing_Broker: ['Andrea Nilson CWP', 'LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243881, 243885],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Commercial Lots Pad Ready - Twin Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 90371,
//       Space_SF: 1110780,
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Commercial Lots Pad Ready - Twin Falls&topParentID=90371&tm_style=__due&cmd=&iList=Property&formID=243881000044443729&formMyID=90371&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 90371,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '780 N. Ten Mile Rd. , Meridian, ID, ',
//       Address1: '780 N. Ten Mile Rd.',
//       Address2: '',
//       Asking_Price: ' 1,300,000.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443700,
//       Land_Size_Acres: 2.24,
//       Listing_Broker: ['Andrea Nilson CWP'],
//       Listing_BrokerDOTmyID: [243881],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Ten Mile and Pine Retail Land - Meridian',
//       Notes: '',
//       Parcel_Number: 'R1581790040',
//       ParentID: 92462,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Ten Mile and Pine Retail Land - Meridian&topParentID=92462&tm_style=__due&cmd=&iList=Property&formID=243881000044443725&formMyID=92462&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-C',
//       cmd: '',
//       myID: 92462,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3295 E. Falcon Dr. , Meridian, ID, ',
//       Address1: '3295 E. Falcon Dr.',
//       Address2: '',
//       Asking_Price: ' 346,000.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443700,
//       Land_Size_Acres: 4.19,
//       Listing_Broker: ['LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243885],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Multi Family Land - Meridian',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 81285,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Multi Family Land - Meridian&topParentID=81285&tm_style=__due&cmd=&iList=Property&formID=243881000044443721&formMyID=81285&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'R8',
//       cmd: '',
//       myID: 81285,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '4330 Overland , Meridian, ID, ',
//       Address1: '4330 Overland',
//       Address2: '',
//       Asking_Price: ' 500,000.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443700,
//       Land_Size_Acres: 4.65,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Overland Land - Meridian',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 121296,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Overland Land - Meridian&topParentID=121296&tm_style=__due&cmd=&iList=Property&formID=243881000044443717&formMyID=121296&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 121296,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '0 Shannon Dr. , Nampa, ID, ',
//       Address1: '0 Shannon Dr.',
//       Address2: '',
//       Asking_Price: ' 407,500.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443700,
//       Land_Size_Acres: 4.66,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Sundowner Parcel - Nampa',
//       Notes: '',
//       Parcel_Number: 'R0799300000',
//       ParentID: 82737,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Sundowner Parcel - Nampa&topParentID=82737&tm_style=__due&cmd=&iList=Property&formID=243881000044443713&formMyID=82737&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'B-C',
//       cmd: '',
//       myID: 82737,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2051 E Pole Line Rd , Twin Falls, ID, ',
//       Address1: '2051 E Pole Line Rd',
//       Address2: '',
//       Asking_Price: ' 1,000,000.00',
//       Building_Size_SqFt: '',
//       City: 'Twin Falls',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443700,
//       Land_Size_Acres: 22,
//       Listing_Broker: ['LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243885],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Pillar Falls Bank Owned Subdivision - Twin Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 13247,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Land',
//       StatusDOTmyID: '202125820',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pillar Falls Bank Owned Subdivision - Twin Falls&topParentID=13247&tm_style=__due&cmd=&iList=Property&formID=243881000044443709&formMyID=13247&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Land',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'PUD',
//       cmd: '',
//       myID: 13247,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '909-1001 E Parkcenter Blvd , Boise, ID, ',
//       Address1: '909-1001 E Parkcenter Blvd',
//       Address2: '',
//       Asking_Price: ' 7,750,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443700,
//       Land_Size_Acres: 6.68,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Southshore Shopping Center - Boise',
//       Notes: '',
//       Parcel_Number: 'R8048801000',
//       ParentID: 115101,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Southshore Shopping Center - Boise&topParentID=115101&tm_style=__due&cmd=&iList=Property&formID=243881000044443705&formMyID=115101&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2',
//       cmd: '',
//       myID: 115101,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '6728 W State St Ste 2 , Boise, ID, ',
//       Address1: '6728 W State St Ste 2',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443700,
//       Land_Size_Acres: 0.7,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'High Visibility Retail Office Space For Lease - Boise',
//       Notes: '',
//       Parcel_Number: 'S0619336441',
//       ParentID: 102182,
//       Space_SF: 7812,
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=High Visibility Retail Office Space For Lease - Boise&topParentID=102182&tm_style=__due&cmd=&iList=Property&formID=243881000044443701&formMyID=102182&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 102182,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1503 Broadway Ave Ste 1 , Boise, ID, ',
//       Address1: '1503 Broadway Ave Ste 1',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443700,
//       Land_Size_Acres: 0.35,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Molenaar Building - Boise',
//       Notes: '',
//       Parcel_Number: 'R1955001076',
//       ParentID: 111018,
//       Space_SF: 4269,
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Molenaar Building - Boise&topParentID=111018&tm_style=__due&cmd=&iList=Property&formID=243881000044443697&formMyID=111018&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 111018,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1028 W Beacon St , Boise, ID, ',
//       Address1: '1028 W Beacon St',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443680,
//       Land_Size_Acres: 0.2,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '02-22-18 15:09:26',
//       Modified_User: 'shannon.hull1',
//       Name: 'Beach Club Tanning Center - Boise',
//       Notes: '',
//       Parcel_Number: 'R8048012932',
//       ParentID: 110643,
//       Seller_Landlord: [
//         'Jim A. Kissler- LLC KISSLER ENTERPRISES LIMITED PARTNERSHIP'
//       ],
//       Seller_LandlordDOTmyID: [289674101],
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Lease',
//       StatusDOTmyID: '144662939',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Beach Club Tanning Center - Boise&topParentID=110643&tm_style=__due&cmd=&iList=Property&formID=243881000044443693&formMyID=110643&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 110643,
//       subFormAction: '',
//       touch: '02-22-18',
//       touchOther: '02-22-18'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '4010 Yellowstone Ave. Ste F , Chubbuck, ID, ',
//       Address1: '4010 Yellowstone Ave. Ste F',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Chubbuck',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443680,
//       Land_Size_Acres: '',
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Construction Now Underway - Chubbuck',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 114440,
//       Space_SF: 11040,
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Construction Now Underway - Chubbuck&topParentID=114440&tm_style=__due&cmd=&iList=Property&formID=243881000044443689&formMyID=114440&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 114440,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1870 S. Meridian Road , Meridian, ID, ',
//       Address1: '1870 S. Meridian Road',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443680,
//       Land_Size_Acres: 0.8,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Retail Strip - Meridian',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 121863,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Retail Strip - Meridian&topParentID=121863&tm_style=__due&cmd=&iList=Property&formID=243881000044443685&formMyID=121863&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 121863,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '6939 W State St , Boise, ID, ',
//       Address1: '6939 W State St',
//       Address2: '',
//       Asking_Price: ' 435,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443680,
//       Land_Size_Acres: 0.99,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: '6939 State Street - Boise',
//       Notes: '',
//       Parcel_Number: 'S0524449402',
//       ParentID: 103839,
//       Space_SF: 2598,
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=6939 State Street - Boise&topParentID=103839&tm_style=__due&cmd=&iList=Property&formID=243881000044443681&formMyID=103839&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2',
//       cmd: '',
//       myID: 103839,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '251 Pole Line Rd. , Twin Falls, ID, ',
//       Address1: '251 Pole Line Rd.',
//       Address2: '',
//       Asking_Price: ' 2,428,881.00',
//       Building_Size_SqFt: '',
//       City: 'Twin Falls',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443680,
//       Land_Size_Acres: 1,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Popeyes Twin Falls Single Tenant NNN Investment - Twin Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 113733,
//       Space_SF: 2600,
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Popeyes Twin Falls Single Tenant NNN Investment - Twin Falls&topParentID=113733&tm_style=__due&cmd=&iList=Property&formID=243881000044443677&formMyID=113733&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 113733,
//       subFormAction: '',
//       touch: '03-14-17',
//       touchOther: '03-14-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '5005 Cleveland Blvd. Ste 1 , Caldwell, ID, ',
//       Address1: '5005 Cleveland Blvd. Ste 1',
//       Address2: '',
//       Asking_Price: ' 1,996,450.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443680,
//       Land_Size_Acres: 0.65,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: "Popeye's Caldwell Absolute NNN Investment For Sale - Caldwell",
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 101812,
//       Space_SF: 2600,
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Popeye%27s Caldwell Absolute NNN Investment For Sale - Caldwell&topParentID=101812&tm_style=__due&cmd=&iList=Property&formID=243881000044443673&formMyID=101812&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 101812,
//       subFormAction: '',
//       touch: '03-14-17',
//       touchOther: '03-14-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1325 N. Happy Valley Rd. , Nampa, ID, ',
//       Address1: '1325 N. Happy Valley Rd.',
//       Address2: '',
//       Asking_Price: ' 2,082,000.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443680,
//       Land_Size_Acres: 0.81,
//       Listing_Broker: ['LeAnn Hume CWP', 'Sara Shropshire CWP'],
//       Listing_BrokerDOTmyID: [243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Nampa Popeyes - Nampa',
//       Notes: '',
//       Parcel_Number: 'R3108700000',
//       ParentID: 101163,
//       Space_SF: 2600,
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Nampa Popeyes - Nampa&topParentID=101163&tm_style=__due&cmd=&iList=Property&formID=243881000044443669&formMyID=101163&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 101163,
//       subFormAction: '',
//       touch: '03-14-17',
//       touchOther: '03-14-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '600 N Milwaukee St Ste 1 , Boise, ID, ',
//       Address1: '600 N Milwaukee St Ste 1',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443680,
//       Land_Size_Acres: 0.95,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Retail Restaurant Space For Lease - Boise',
//       Notes: '',
//       Parcel_Number: 'R9316750100',
//       ParentID: 101444,
//       Space_SF: 6857,
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Retail Restaurant Space For Lease - Boise&topParentID=101444&tm_style=__due&cmd=&iList=Property&formID=243881000044443665&formMyID=101444&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 101444,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1612 S. Broadway Ave. , Boise, ID, ',
//       Address1: '1612 S. Broadway Ave.',
//       Address2: '',
//       Asking_Price: ' 1,975,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443650,
//       Land_Size_Acres: 0.39,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: "Popeye's Absolute NNN Investment For Sale - Boise",
//       Notes: '',
//       Parcel_Number: 'R5315001822',
//       ParentID: 108444,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Popeye%27s Absolute NNN Investment For Sale - Boise&topParentID=108444&tm_style=__due&cmd=&iList=Property&formID=243881000044443661&formMyID=108444&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 108444,
//       subFormAction: '',
//       touch: '03-14-17',
//       touchOther: '03-14-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1129 S. Broadway Ave. , Boise, ID, ',
//       Address1: '1129 S. Broadway Ave.',
//       Address2: '',
//       Asking_Price: '',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Deal_Type: ['Lease'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443650,
//       Land_Size_Acres: 3200,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Hong Kong Spa',
//       Notes:
//         'Grey Shell - Rent = 30sf; TI = 37.50-over heatedcooled grey shell. ',
//       Parcel_Number: 'R8048012920',
//       ParentID: 115342,
//       Seller_Landlord: [
//         'Jim A. Kissler- LLC KISSLER ENTERPRISES LIMITED PARTNERSHIP'
//       ],
//       Seller_LandlordDOTmyID: [289674101],
//       Space_SF: 3200,
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Hong Kong Spa&topParentID=115342&tm_style=__due&cmd=&iList=Property&formID=243881000044443657&formMyID=115342&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 115342,
//       subFormAction: '',
//       touch: '01-09-18',
//       touchOther: '01-09-18'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '5009 Cleveland Blvd. , Caldwell, ID, ',
//       Address1: '5009 Cleveland Blvd.',
//       Address2: '',
//       Asking_Price: ' 2,307,949.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443650,
//       Land_Size_Acres: 0.91,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Freddys Caldwell - Absolute NNN Investment For Sale - Caldwell',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 101811,
//       Space_SF: 3435,
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Freddys Caldwell - Absolute NNN Investment For Sale - Caldwell&topParentID=101811&tm_style=__due&cmd=&iList=Property&formID=243881000044443653&formMyID=101811&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 101811,
//       subFormAction: '',
//       touch: '03-14-17',
//       touchOther: '03-14-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '111 S Broadway Ave Ste 129 , Boise, ID, ',
//       Address1: '111 S Broadway Ave Ste 129',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443650,
//       Land_Size_Acres: 1.33,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Broadway 111 Plaza - Boise',
//       Notes: '',
//       Parcel_Number: 'S1010417650',
//       ParentID: 107407,
//       Space_SF: 14620,
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Broadway 111 Plaza - Boise&topParentID=107407&tm_style=__due&cmd=&iList=Property&formID=243881000044443649&formMyID=107407&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-1DD',
//       cmd: '',
//       myID: 107407,
//       subFormAction: '',
//       touch: '01-26-17',
//       touchOther: '01-26-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1709 Caldwell Blvd. , Nampa, ID, ',
//       Address1: '1709 Caldwell Blvd.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443650,
//       Land_Size_Acres: 0.32,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Cafe Zupas - Nampa',
//       Notes: '',
//       Parcel_Number: 'R3134800000',
//       ParentID: 111930,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Cafe Zupas - Nampa&topParentID=111930&tm_style=__due&cmd=&iList=Property&formID=243881000044443645&formMyID=111930&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 111930,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2260 N. Eagle Rd. Ste M-100 & M-110 , Meridian, ID, ',
//       Address1: '2260 N. Eagle Rd. Ste M-100 & M-110',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443650,
//       Land_Size_Acres: 24.2,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'The Village at Meridian North Phase - Meridian',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 101809,
//       Space_SF: 250521,
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=The Village at Meridian North Phase - Meridian&topParentID=101809&tm_style=__due&cmd=&iList=Property&formID=243881000044443641&formMyID=101809&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 101809,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '4977 W Fairview Ave Ste 1 , Boise, ID, ',
//       Address1: '4977 W Fairview Ave Ste 1',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443650,
//       Land_Size_Acres: 0.32,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Office Flex Building For Sale & Lease - Boise',
//       Notes: '',
//       Parcel_Number: 'R7777808102',
//       ParentID: 106668,
//       Space_SF: 4763,
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Office Flex Building For Sale & Lease - Boise&topParentID=106668&tm_style=__due&cmd=&iList=Property&formID=243881000044443637&formMyID=106668&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-3D',
//       cmd: '',
//       myID: 106668,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '7227 W. State St. , Garden City, ID, ',
//       Address1: '7227 W. State St.',
//       Address2: '',
//       Asking_Price: ' 3,170,000.00',
//       Building_Size_SqFt: '',
//       City: 'Garden City',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443650,
//       Land_Size_Acres: 0.44,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Single Tenant NNN Leased Investment - Garden City',
//       Notes: '',
//       Parcel_Number: 'R8143000043',
//       ParentID: 106612,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Single Tenant NNN Leased Investment - Garden City&topParentID=106612&tm_style=__due&cmd=&iList=Property&formID=243881000044443633&formMyID=106612&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'PAR 0043 OF LOTS 1 & 2 STEWARTS SUB 0041-B 9407',
//       cmd: '',
//       myID: 106612,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '687 S. Blue Lakes Blvd N , Twin Falls, ID, ',
//       Address1: '687 S. Blue Lakes Blvd N',
//       Address2: '',
//       Asking_Price: ' 850,000.00',
//       Building_Size_SqFt: '',
//       City: 'Twin Falls',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443620,
//       Land_Size_Acres: 0.98,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'New Retail Restaurant Space For Lease - Twin Falls',
//       Notes: '',
//       Parcel_Number: 'RPT00107091800A',
//       ParentID: 41476,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=New Retail Restaurant Space For Lease - Twin Falls&topParentID=41476&tm_style=__due&cmd=&iList=Property&formID=243881000044443629&formMyID=41476&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-1',
//       cmd: '',
//       myID: 41476,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1555 S Broadway Ave , Boise, ID, ',
//       Address1: '1555 S Broadway Ave',
//       Address2: '',
//       Asking_Price: ' 1,745,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443620,
//       Land_Size_Acres: 0.79,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Tilted Kilt - Boise',
//       Notes: '',
//       Parcel_Number: 'R1955001095',
//       ParentID: 111953,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Tilted Kilt - Boise&topParentID=111953&tm_style=__due&cmd=&iList=Property&formID=243881000044443625&formMyID=111953&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 111953,
//       subFormAction: '',
//       touch: '03-14-17',
//       touchOther: '03-14-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '6907 N Strawberry Glenn Rd Ste 110 , Garden City, ID, ',
//       Address1: '6907 N Strawberry Glenn Rd Ste 110',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Garden City',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443620,
//       Land_Size_Acres: 2.63,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Oliver Finley Plaza - Garden City',
//       Notes: '',
//       Parcel_Number: 'S0524427910',
//       ParentID: 94585,
//       Space_SF: 48125,
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Oliver Finley Plaza - Garden City&topParentID=94585&tm_style=__due&cmd=&iList=Property&formID=243881000044443621&formMyID=94585&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-1',
//       cmd: '',
//       myID: 94585,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '0 Cleveland & Ustick Rd. , Caldwell, ID, ',
//       Address1: '0 Cleveland & Ustick Rd.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443620,
//       Land_Size_Acres: 5.15,
//       Listing_Broker: ['Andrea Nilson CWP'],
//       Listing_BrokerDOTmyID: [243881],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Caldwell Commons - Caldwell',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 107681,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Caldwell Commons - Caldwell&topParentID=107681&tm_style=__due&cmd=&iList=Property&formID=243881000044443617&formMyID=107681&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 107681,
//       subFormAction: '',
//       touch: '02-16-17',
//       touchOther: '02-16-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '10530 W. Carlton Bay Dr. , Garden City, ID, ',
//       Address1: '10530 W. Carlton Bay Dr.',
//       Address2: '',
//       Asking_Price: ' 4,700,000.00',
//       Building_Size_SqFt: '',
//       City: 'Garden City',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443620,
//       Land_Size_Acres: 1.45,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name:
//         'Walgreens Absolute NNN Leased Investment For Sale Walgreens - Garden City',
//       Notes: '',
//       Parcel_Number: 'R1292650040',
//       ParentID: 104457,
//       Space_SF: 14550,
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Walgreens Absolute NNN Leased Investment For Sale Walgreens - Garden City&topParentID=104457&tm_style=__due&cmd=&iList=Property&formID=243881000044443613&formMyID=104457&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'M-U',
//       cmd: '',
//       myID: 104457,
//       subFormAction: '',
//       touch: '03-14-17',
//       touchOther: '03-14-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '4700 & 4720 W Emerald St , Boise, ID, ',
//       Address1: '4700 & 4720 W Emerald St',
//       Address2: '',
//       Asking_Price: ' 600,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443620,
//       Land_Size_Acres: 0.8,
//       Listing_Broker: ['LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243885],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Emerald Park Office - Boise',
//       Notes: '',
//       Parcel_Number: 'R7777807061 R7777807082',
//       ParentID: 97007,
//       Space_SF: 16048,
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Emerald Park Office - Boise&topParentID=97007&tm_style=__due&cmd=&iList=Property&formID=243881000044443609&formMyID=97007&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'C-2D',
//       cmd: '',
//       myID: 97007,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '7227 W. State St. , Garden City, ID, ',
//       Address1: '7227 W. State St.',
//       Address2: '',
//       Asking_Price: ' 850,000.00',
//       Building_Size_SqFt: '',
//       City: 'Garden City',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443620,
//       Land_Size_Acres: 0.45,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: '7227 W State St - Garden City',
//       Notes: 'PAR 0043 OF LOTS 1 & 2 STEWARTS SUB 0041-B 9407',
//       Parcel_Number:
//         'R8143000043  PAR 0043 OF LOTS 1 & 2 STEWARTS SUB 0041-B 9407',
//       ParentID: 101246,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Investment',
//       StatusDOTmyID: '263506298',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=7227 W State St - Garden City&topParentID=101246&tm_style=__due&cmd=&iList=Property&formID=243881000044443605&formMyID=101246&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 101246,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: 'SWC Meridian Rd & Cherry Ln. , Meridian, ID, ',
//       Address1: 'SWC Meridian Rd & Cherry Ln.',
//       Address2: '',
//       Asking_Price: ' 490,000.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443620,
//       Land_Size_Acres: 0.59,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Human Bean - Meridian',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 115378,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Human Bean - Meridian&topParentID=115378&tm_style=__due&cmd=&iList=Property&formID=243881000044443601&formMyID=115378&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 115378,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '3180 E. Lanark St. , Meridian, ID, ',
//       Address1: '3180 E. Lanark St.',
//       Address2: '',
//       Asking_Price: ' 687,610.00',
//       Building_Size_SqFt: '',
//       City: 'Meridian',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443600,
//       Land_Size_Acres: 0.82,
//       Listing_Broker: ['Andrea Nilson CWP', 'LeAnn Hume CWP'],
//       Listing_BrokerDOTmyID: [243881, 243885],
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: '3180 E Lanark St - Meridian',
//       Notes: '',
//       Parcel_Number: 'R6510580012',
//       ParentID: 96350,
//       Space_SF: 7000,
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=3180 E Lanark St - Meridian&topParentID=96350&tm_style=__due&cmd=&iList=Property&formID=243881000044443597&formMyID=96350&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'B1',
//       cmd: '',
//       myID: 96350,
//       subFormAction: '',
//       touch: '03-19-17',
//       touchOther: '03-19-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '2500 E Blaine St , Caldwell, ID, ',
//       Address1: '2500 E Blaine St',
//       Address2: '',
//       Asking_Price: ' 1,100,000.00',
//       Building_Size_SqFt: '',
//       City: 'Caldwell',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443600,
//       Land_Size_Acres: 3.62,
//       Modified_Time: '12-18-17 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Albertsons - Caldwell',
//       Notes: '',
//       Parcel_Number: 'R3536500000',
//       ParentID: 103219,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Albertsons - Caldwell&topParentID=103219&tm_style=__due&cmd=&iList=Property&formID=243881000044443593&formMyID=103219&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 103219,
//       subFormAction: '',
//       touch: '03-19-17',
//       touchOther: '03-19-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '0 Pole Line Rd. , Twin Falls, ID, ',
//       Address1: '0 Pole Line Rd.',
//       Address2: '',
//       Asking_Price: ' 725,000.00',
//       Building_Size_SqFt: '',
//       City: 'Twin Falls',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443600,
//       Land_Size_Acres: 1,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:01',
//       Modified_User: 'ensobase',
//       Name: 'Westpark Shopping Center - Twin Falls',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 112096,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Westpark Shopping Center - Twin Falls&topParentID=112096&tm_style=__due&cmd=&iList=Property&formID=243881000044443589&formMyID=112096&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 112096,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1205 1209 1219 1221 S Broadway Ave , Boise, ID, ',
//       Address1: '1205 1209 1219 1221 S Broadway Ave',
//       Address2: '',
//       Asking_Price: ' 3,768,200.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443600,
//       Land_Size_Acres: 4.24,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '12-18-17 00:00:01',
//       Modified_User: 'ensobase',
//       Name: 'Broadway Plaza - Boise',
//       Notes: '',
//       Parcel_Number: 'R8048012342 R8048013008',
//       ParentID: 110620,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Broadway Plaza - Boise&topParentID=110620&tm_style=__due&cmd=&iList=Property&formID=243881000044443585&formMyID=110620&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'City of Boise-C-2D',
//       cmd: '',
//       myID: 110620,
//       subFormAction: '',
//       touch: '01-26-17',
//       touchOther: '01-26-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1602-1626 S. Broadway Ave. , Boise, ID, ',
//       Address1: '1602-1626 S. Broadway Ave.',
//       Address2: '',
//       Asking_Price: ' 800,000.00',
//       Building_Size_SqFt: '',
//       City: 'Boise',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443600,
//       Land_Size_Acres: 1.47,
//       Modified_Time: '12-18-17 00:00:01',
//       Modified_User: 'ensobase',
//       Name: 'New Broadway Retail Space For Lease - Boise',
//       Notes: '',
//       Parcel_Number: 'R5315001780',
//       ParentID: 101235,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=New Broadway Retail Space For Lease - Boise&topParentID=101235&tm_style=__due&cmd=&iList=Property&formID=243881000044443581&formMyID=101235&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'City-of-Boise C-2D',
//       cmd: '',
//       myID: 101235,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '4122 Yellowstone Ave , Pocatello, ID, ',
//       Address1: '4122 Yellowstone Ave',
//       Address2: '',
//       Asking_Price: ' 9,075,000.00',
//       Building_Size_SqFt: '',
//       City: 'Pocatello',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443600,
//       Land_Size_Acres: 5.77,
//       Listing_Broker: ['LeAnn Hume CWP', 'Sara Shropshire CWP'],
//       Listing_BrokerDOTmyID: [243885, 243888],
//       Modified_Time: '12-18-17 00:00:01',
//       Modified_User: 'ensobase',
//       Name: 'Cobblestone Creek - Pocatello',
//       Notes: '',
//       Parcel_Number: 'RPBMT000606',
//       ParentID: 86052,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Cobblestone Creek - Pocatello&topParentID=86052&tm_style=__due&cmd=&iList=Property&formID=243881000044443577&formMyID=86052&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'CG C-2',
//       cmd: '',
//       myID: 86052,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1435 N Happy Valley Rd , Nampa, ID, ',
//       Address1: '1435 N Happy Valley Rd',
//       Address2: '',
//       Asking_Price: ' 1,000,000.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443600,
//       Land_Size_Acres: 1.78,
//       Modified_Time: '12-18-17 00:00:01',
//       Modified_User: 'ensobase',
//       Name: 'Nampa Gateway Pad 5 - Nampa',
//       Notes: '',
//       Parcel_Number: '3108600000 &  R3108610300',
//       ParentID: 99264,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Nampa Gateway Pad 5 - Nampa&topParentID=99264&tm_style=__due&cmd=&iList=Property&formID=243881000044443573&formMyID=99264&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 99264,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '4010 Yellowstone Ave. , Chubbuck, ID, ',
//       Address1: '4010 Yellowstone Ave.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Chubbuck',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443600,
//       Land_Size_Acres: '',
//       Modified_Time: '12-18-17 00:00:01',
//       Modified_User: 'ensobase',
//       Name: 'Pole Line & Yellowstone - Chubbuck',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 112182,
//       Space_SF: '',
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Pole Line & Yellowstone - Chubbuck&topParentID=112182&tm_style=__due&cmd=&iList=Property&formID=243881000044443569&formMyID=112182&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 112182,
//       subFormAction: '',
//       touch: '12-31-16',
//       touchOther: '12-31-16'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '1509 Caldwell Blvd Ste 1234 , Nampa, ID, ',
//       Address1: '1509 Caldwell Blvd Ste 1234',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Nampa',
//       Deal_Type: ['Lease', 'Investment'],
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443550,
//       Land_Size_Acres: 34.93,
//       Listing_Broker: [
//         'Andrea Nilson CWP',
//         'LeAnn Hume CWP',
//         'Sara Shropshire CWP'
//       ],
//       Listing_BrokerDOTmyID: [243881, 243885, 243888],
//       Modified_Time: '05-03-18 00:00:02',
//       Modified_User: 'ensobase',
//       Name: 'Karcher Mall - Nampa',
//       Notes: '',
//       Parcel_Number: 'R1214310300',
//       ParentID: 92214,
//       Seller_Landlord: ['Karcher Capital LP '],
//       Seller_LandlordDOTmyID: [286203835],
//       Space_SF: 407159,
//       State_Province: 'ID',
//       Status: 'Active Property',
//       StatusDOTmyID: '216735038',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Karcher Mall - Nampa&topParentID=92214&tm_style=__due&cmd=&iList=Property&formID=243881000044443565&formMyID=92214&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: 'Freestanding',
//       Zip_Postal_Code: '',
//       Zoning: 'Commercial',
//       cmd: '',
//       myID: 92214,
//       subFormAction: '',
//       touch: '12-11-17',
//       touchOther: '12-19-17'
//     },
//     {
//       Added_Time: '12-31-16 00:12:35',
//       Added_User: 'ensobase',
//       Address: '730-1030 S. 16th St. , Payette, ID, ',
//       Address1: '730-1030 S. 16th St.',
//       Address2: '',
//       Asking_Price: ' 0.00',
//       Building_Size_SqFt: '',
//       City: 'Payette',
//       Escalation: '',
//       Escalation_Note: '',
//       Form_Type: 'Property',
//       Form_TypeDOTmyID: '197081',
//       ID: 243881000044443550,
//       Land_Size_Acres: 0.99,
//       Listing_Broker: ['Retail Team  '],
//       Listing_BrokerDOTmyID: [758499208],
//       Modified_Time: '12-18-17 00:00:01',
//       Modified_User: 'ensobase',
//       Name: 'Land At Highway 95 & 16th - Payette',
//       Notes: '',
//       Parcel_Number: '',
//       ParentID: 116710,
//       Space_SF: 43124,
//       State_Province: 'ID',
//       Status: 'Comp - Confidential',
//       StatusDOTmyID: '202081877',
//       TMLink:
//         'http:209.200.78.201cwhome.html?page=taskmanager&topParentName=Land At Highway 95 & 16th - Payette&topParentID=116710&tm_style=__due&cmd=&iList=Property&formID=243881000044443561&formMyID=116710&formType=Property&iContactID=',
//       TopParentStatus: 'Comp - Confidential',
//       Type: '',
//       Zip_Postal_Code: '',
//       Zoning: '',
//       cmd: '',
//       myID: 116710,
//       subFormAction: '',
//       touch: '04-19-17',
//       touchOther: '04-19-17'
//     }
//   ]
// }
// / /////////////////////////////////==
